// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/email-img.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/blg-banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27%23333%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M8 0a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2H9v6a1 1 0 1 1-2 0V9H1a1 1 0 0 1 0-2h6V1a1 1 0 0 1 1-1z%27 clip-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27%23333%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M0 8a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1z%27 clip-rule=%27evenodd%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  list-style: none;
}

a {
  text-decoration: none;
}

.activeLeads {
   background: #000;
}

section.activeLeads{
  padding: 60px 0px;
}
section.activeLeads h3 {
font-size: 2.2rem;
color: #fff;
padding-bottom: 15px;
}
section.activeLeads p {
  color: #fff;
}
.aLeadImg{
  width: 90% !important;
}

section.intendData {
  padding: 60px 0px;
}
section.intendData h3 {
  font-size: 2.2rem;
  padding-bottom: 15px;
}

.campaignLink{

  color: #fff;
  padding: 10px 0px;
}
.arrWImg{
  width: 30px !important;
}

section.insights{
  padding: 60px 0px;
}

section.insights .imgWrap{
width: 100%;
height: 350px;
position: relative;
}

section.insights .imgWrap img.insightBI{
 width: 100%;
 height: 100%;
 position: absolute;
 top: 0px;
 left: 0px;
 z-index: 1;
}

section.insights .imgWrap .coverTG{
  width: 100%;
  height: 100%;
  padding: 20px;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 2;
  background: rgb(85,181,109);
  background: linear-gradient(180deg, rgba(85,181,109,0.85) 0%, rgba(8,117,166,0.85) 100%);
 }

 section.insights h3{
  font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 40px;
    line-height: 50px;
    text-align: center;
    color: #202020;
    margin-bottom: 35px;
 }

 section.insights h5 {
  font-size: 1.2rem;
  font-weight: 400;
  color: #fff;
  padding-bottom: 15px;
  }
  section.insights p {
    font-size: 1.4rem;
    font-weight: 600;
    color: #fff;
    line-height: 35px;;
  }




.ultimate {
  background-color: #000;
  padding: 60px 0px;
  padding-top: 75px;
}

.ultimate-inner p {
  margin-bottom: 0px;
  font-size: 1rem;
  color: #fff;
}

.cmtMinH{
  min-height: 850px;
}

.cmtMinH2{
  min-height: 920px;
}

.ultimate-inner {
  box-shadow: 0px 8px 41px -9px rgba(0, 0, 0, 0.09);
  background-color: #000;
  padding: 30px 25px;
  margin-bottom: 25px;
  border: 1px solid grey;
}

.ultimate-inner img {
  width: 65px;
  /* margin-bottom: 12px; */
}
.ultimate-inner h5 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 1.2rem;
  line-height: 28px;
  color: #55b56d;
  margin-bottom: 4px;
}

.ultimate h3 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 40px;
  line-height: 50px;
  color: #fff;
  text-align: center;
  margin-bottom: 35px;
}

.maine-header .navbar-brand img {
  width: 90%;
}

ul.mrkts {
  margin: 0px;
  padding: 0px;
  display: inline-block;
  padding-left: 17px;
}

ul.mrkts li {
  list-style: none;
  float: left;
  width: 33%;
  font-size: 13px;
  color: #fff;
  font-family: "Poppins";
  margin-bottom: 6px;
  line-height: 18px;
  text-align: left;
  height: 36px;
  list-style-type: disc;
}

.profile-jobs img {
  width: 65% !important;
  margin: 0 auto;
  display: block;
}
.profile-jobs {
  padding: 0px 70px;
}

.profile-jobs h5 {
  text-align: center !important;
  margin-top: 15px;
  margin-bottom: 3px;
}

.profile-jobs h6 {
  color: #fff;
  font-size: 14px;
  font-weight: 400;
}

.ourmembers h3 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 40px;
  line-height: 50px;
  color: #202020;
  text-align: center;
  margin-bottom: 35px;
}

.ourmembers {
  padding: 45px 0px;
  background-color: #f9f9f9;
}

.maine-banner-inner ul {
  padding: 0px;
  margin: 0px;
  flex-wrap: wrap;
}
.maine-banner-inner ul li {
  width: 50%;
  line-height: 36px;
}
.maine-banner-inner ul li img {
  width: 7%;
  margin-right: 12px;
}

/*.maine-header .navbar-brand {
 padding:0px; 
}*/
.form-control:focus {
  box-shadow: none;
}
p {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}

img {
  width: 100%;
}

.start-right img {
  width: 39%;
  margin: 0 auto;
  display: block;
}

.start-right {
  padding: 50px 50px;
  text-align: center;
}

.container {
  padding-left: 0px;
  padding-right: 0px;
}
.maine-header {
  background-color: #fff;
}

/* .lead-menu .navbar-brand img {
  width: 175px;
} */

.lead-menu {
  padding: 0;
}

.lead-menu .navbar-nav {
  width: 89%;
}

.lead-menu .navbar-nav .nav-link {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 18px;
  color: #000000;
  padding: 25px 10px;
  display: block;
}

.lead-menu .navbar-nav .nav-link.active {
  color: #55b56d;
}

.lead-menu .navbar-nav > :hover .nav-link {
  color: #55b56d;
}

.btn-login {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 18px;
  color: #000000;
  padding: 15px 30px;
}

.btn-sign {
  background-color: #55b56d;
  border: 1px solid #55b56d;
  transition: 0.5s;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 18px;
  color: #f9f9f9;
  border-radius: 0px;
  padding: 9px 19px;
  height: 40px;
  margin-top: 4px;
}
.btn-after {
  background-color: #55b56d;
  border: 1px solid #55b56d;
  transition: 0.5s;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 18px;
  color: #f9f9f9;
  border-radius: 0px;
  padding: 10px 19px;
  margin-top: 4px;
}

:hover.btn-after {
  background-color: unset;
  color: #55b56d;
  border-color: #55b56d;
}

.lead-box ul {
  padding: 0px;
  margin: 0px;
  display: inline-block;
}

.lead-box ul li {
  list-style: none;
  float: left;
  margin-right: 10px;
  background-color: #55b56d;
  width: 35px;
  height: 35px;
  border-radius: 5px;
  padding: 5px 10px;
  text-align: center;
  border: 1px solid #55b56d;
}

.lead-box ul li a {
  color: #fff;
}

.maine-banner {
  background-color: #ffffff;
  padding: 60px 0px;
}
.maine-banner-inner {
  padding: 0px 0px;
  padding-top: 20px;
}

/* :hover.lead-box {
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.2);
} */

.maine-banner-inner h2 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 40px;
  line-height: 52px;
  text-align: left;
  padding-right: 40px;
}

.yellow-title {
  color: #55b56d;
}

.active-main-right h4 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 40px;
  line-height: 50px;
  color: #fff;
  text-align: left;
}

.active-main-right p {
  color: #fff;
  text-align: left;
}

.active-main-left {
  width: 35%;
}

.active-main-right {
  width: 65%;
  padding-left: 70px;
}

.active-main-left img {
  width: 100% !important;
  height: 100% !important;
}
.out-right img {
  position: relative;
  top: -60px;
}

.out-right img {
  position: relative;
  top: -60px;
}

.out-left {
  padding-right: 110px;
  padding-top: 40px;
}

.target-box ul {
  padding: 0px;
  margin: 0px;
}

.target-box ul li img {
  width: 55px !important;
  height: 55px !important;
  float: left;
  margin-right: 10px;
}

.target-box ul li {
  width: 100%;
}

.target-box ul li h6 {
  text-align: left;
  color: #fff;
  padding-top: 7px;
  line-height: 22px;
  font-weight: 400;
}

.target-box ul li h6 span {
  color: #55b56d;
  font-size: 20px;
  font-weight: 700;
}

.comanies-main-left ul {
  padding: 0px;
  margin: 0px;
}

.comanies-main-left ul li {
  float: left;
  /* width: 26%; */
  margin-right: 12px;
  margin-top: 6px;
}

.comanies-main-left {
  width: 65%;
}

/* .comanies-main-right {
  width: 35%;
} */

.comanies-main-right .btn-lead {
  margin-top: 35px;
  display: inline-block;
  border-color: #fff;
  color: #fff;
  margin-right: 10px;
}

.main-counter {
  flex-wrap: wrap;
}

.counter {
  width: 50%;
  margin: 0 auto;
}

.counter .counter-value {
  color: #55b56d;
  font-size: 25px;
  font-weight: 500;
  width: 66px;
  margin: 0 auto;
}

.counter h5 {
  font-size: 15px;
  color: #252525;
}

.counter small {
  font-size: 25px;
  color: #55b56d;
}

.maine-banner-inner h5 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 1.2rem;
  line-height: 30px;
  color: #a9a9a9;
  text-align: left;
  padding-right: 35px;
  margin-top: 15px;
}

.main-vision .ultimate-inner p {
  height: 120px;
}

.join-p {
  background-color: #55b56d;
  padding: 20px 20px;
  border-radius: 5px;
  color: #fff;
  font-size: 18px;
  line-height: 28px;
  text-align: justify;
}

.maine-banner-left img {
  width: 100%;
  position: relative;
}

.input-talk input {
  box-shadow: 0px 8px 41px -9px rgba(0, 0, 0, 0.09);
  background-color: #fdfdfd;
  border: 1px solid #ffff;
  height: 50px;
  margin-right: 20px;
  border-radius: 0px;
}

.input-talk input::placeholder {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 15px;
  color: #787272;
}

.input-talk #basic-addon2 {
  border-radius: 0px;
  border: 1px solid #55b56d;
  background-color: #55b56d;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 18px;
  color: #ffffff;
  padding: 0px 28px;
  cursor: pointer;
}

.input-talk {
  padding-right: 110px;
  padding-top: 20px;
}

.input-talk input:focus {
  border-color: #55b56d;
}

.footer-top-1 .input-group input::placeholder {
  color: #fff;
}

:hover.btn-sign {
  background-color: unset;
  color: #55b56d;
  border-color: #55b56d;
}

.input-talk:hover #basic-addon2 {
  background-color: unset;
  color: #55b56d;
  border-color: #55b56d;
}

.our-leads-inner {
  position: relative;
}
.our-leads-inner img {
  height: 700px;
}

.our-leads-caption {
  position: absolute;
  left: 70px;
  top: 55px;
  width: 90%;
}
.active-main {
  padding-top: 35px;
}

.our-leads-caption h3 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 40px;
  line-height: 50px;
  color: #ffffff;
  margin-bottom: 22px;
}

.our-leads-caption h5 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  color: #ffffff;
  text-align: left;
}

.comanies-main {
  padding-top: 10px;
}

.show-selet select {
  background-color: unset;
  border: 1px solid #333;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  filter: invert(1);
  border-radius: 8px;
  width: 120px;
}

.show-selet select option {
  color: #fff;
  background-color: #000c2f;
}

.total-tb {
  width: 100%;
}

.total-box {
  background: rgba(26, 26, 26, 0.65);
  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.17);
  -webkit-backdrop-filter: blur(30px);
          backdrop-filter: blur(30px);
  border-radius: 12px;
  width: 100%;
  margin-top: 10px;
  padding: 30px 20px;
  padding-bottom: 40px;
}

.total-rate h6 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  color: #ffffff;
  width: 100%;
  text-align: left;
}

.share-no h2 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 45px;
  line-height: 74px;
  color: #ffffff;
  width: 36%;
}

.share-no h6 {
  font-style: inherit;
  font-weight: 600;
  font-size: 24px;
  line-height: 33px;
  font-family: "Poppins";
  color: #14e644;
  width: 25%;
  padding-top: 26px;
}

.compared-box p {
  color: #a1a1a1;
  text-align: left;
  margin-bottom: 30px;
}

.progress-title {
  font-size: 16px !important;
  font-weight: 400 !important;
  color: #000;
  margin: 0 0 10px 0 !important;
  line-height: 9px !important;
  width: 145px;
  text-align: left;
}
.progress {
  height: 8px;
  line-height: 12px;
  border-radius: 20px;
  background: #f0f0f0;
  margin-bottom: 30px;
  box-shadow: none;
  overflow: visible;
  width: 65%;
  margin-right: 15px;
}
.progress .progress-bar {
  position: relative;
  border-radius: 20px 0 0 20px;
  animation: animate-positive 2s;
}
.progress .progress-value {
  display: none;
  font-size: 13px;
  color: #fff;
  position: absolute;
  top: 0;
  right: 8px;
}
.progess-box-inner img {
  width: 25px !important;
  margin-top: -5px;
  margin-right: 12px;
}

.progess-box-inner {
  margin-top: 10px;
}
@keyframes animate-positive {
  0% {
    width: 0%;
  }
}

.clients-box img {
  width: 165px;
  margin: 0 auto;
  display: block;
}

.clients {
  padding: 45px 0px;
  border-top: 1px solid #f2f2f2;
  margin: 60px 0px;
  border-bottom: 1px solid #f2f2f2;
}

.inbound h3 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 40px;
  line-height: 50px;
  text-align: center;
  padding: 0px 285px;
  margin-bottom: 45px;
}

.inbound .nav-pills .nav-link.active,
.inbound .nav-pills .show > .nav-link {
  color: #fff;
  background-color: #1f4572;
  border-radius: 6px;
  position: relative;
}
.inbound .nav-pills .nav-link.active:after,
.inbound .nav-pills .show > .nav-link:after {
  border-bottom: 15px solid transparent;
  border-left: 15px solid #1f4572;
  border-top: 15px solid transparent;
  bottom: -20px;
  content: "";
  height: 0;
  position: absolute;
  width: 0;
  transform: rotate(90deg);
  left: 50px;
}
.inbound .nav-pills .nav-link img {
  width: 70px;
  margin: 0 auto 12px;
}

.inbound .nav-pills .nav-link.active img,
.inbound .nav-pills .show > .nav-link img {
  filter: invert(1);
}

.inbound .nav-pills .nav-link {
  width: 205px;
  margin-right: 20px;
  height: 205px;
  padding: 40px 38px;
  text-align: center;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  color: #202020;
}

.inbound .row {
  padding: 0px 125px;
}

.inbound .tab-content h4 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 30px;
  color: #131416;
  margin-bottom: 15px;
  margin-top: 20px;
}

.btn-fnd {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 18px;
  color: #1f4572;
}
.inbound .tab-content p {
  padding-right: 175px;
}

.out {
  padding: 60px 0px;
  padding-bottom: 0px;
  background: #000;
}

.out-white {
  padding: 60px 0px;
  padding-bottom: 0px;
}

.have-left img {
  width: 100%;
  position: relative;
  top: 55px;
}

.start-left ul {
  padding: 0px;
  margin: 0px;
  flex-wrap: wrap;
}

.start-left ul li {
  width: 50%;
  line-height: 36px;
}

.start-left ul li img {
  width: 7%;
  margin-right: 12px;
}

.million-box img {
  width: 12%;
  margin-right: 15px;
  height: 60px;
}

.million-box {
  padding-bottom: 5px;
}

.million-box-right h5 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  padding-right: 150px;
}

.million-box-right h5 span {
  font-weight: 700;
}

.out h3 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 40px;
  line-height: 50px;
  color: #202020;
  padding-right: 80px;
}

.out-left p {
  color: #565656;
  margin-bottom: 22px;
}

.out-left ul {
  padding: 0px;
  margin: 0px;
}

.out-left ul li {
  float: left;
  width: 50%;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 38px;
}

.out-left ul li i {
  margin-right: 10px;
}

.btn-lead {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 18px;
  color: #55b56d;
  border: 1px solid #55b56d;
  transition: 0.5s;
  padding: 12px 25px;
  margin-top: 20px;
  display: inline-block;
  border-radius: 5px;
}

:hover.btn-lead {
  background-color: #55b56d;
  color: #fff;
}

.btn-lead-hero {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
  color: #fff;
  border: 1px solid #55b56d;
  transition: 0.5s;
  padding: 15px 30px;
  display: inline-block;
  border-radius: 5px;
  background: #55b56d;
}

:hover.bgn-now {
  background-color: #55b56d;
  color: #fff;
}

.mali-box {
  background: #ffffff;
  box-shadow: 0px 25px 70px 10px rgba(0, 0, 0, 0.08);
  padding: 35px 25px;
  margin-top: 20px;
  position: relative;
  left: 100px;
  top: 20px;
}

.mali-box i {
  width: 50px;
  height: 50px;
  text-align: center;
  background-color: #e9f2ff;
  border-radius: 50%;
  padding: 16px 16px;
  color: #1f4572;
  margin-bottom: 10px;
}

.mali-box h5 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 23px;
  color: #1f4572;
}

.mali-box p {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #242426;
  margin-bottom: 0px;
}

.mali {
  width: 50%;
  flex-wrap: wrap;
}

.sami-box {
  background: #1f4572;
  box-shadow: 0px 19px 33px -17px rgba(0, 0, 0, 0.25);
  width: 215px;
  padding: 12px 15px;
}

.sami-box img {
  width: 40px;
  border-radius: 50%;
  margin-right: 10px;
}

.sami-box h6 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 15px;
  color: #ffffff;
  margin-bottom: 0px;
  margin-top: 6px;
}

.sami-box {
  background: #1f4572;
  box-shadow: 0px 19px 33px -17px rgba(0, 0, 0, 0.25);
  width: 215px;
  padding: 12px 15px;
  position: absolute;
  right: 95px;
  z-index: 9;
  top: 20px;
}

.out-right {
  position: relative;
}

.mali-box-2:after {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 100%;
  height: 80%;
  position: absolute;
  top: -89px;
  right: -279px;
  background-repeat: no-repeat;
  background-size: contain;
}

.mali-box-2 {
  position: relative;
}

.have-right h3 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 40px;
  line-height: 50px;
  color: #fff;
}

.have-right p {
  color: #fff;
  margin-bottom: 22px;
}

/* .have-left {
  
  width: 85%;
  padding: 135px 30px;
  position: relative;
  background-image: url(../images/uplaod-img.png);
  height: 100%;
} */

.lead-eng h5 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 17px;
  line-height: 18px;
  color: #2b2b2b;
}

.lead-eng h6 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  margin-bottom: 0px;
}

.lead-eng h6 span {
  color: #848484;
}

.lead-eng {
  background: #ffffff;
  box-shadow: 0px 9px 40px -10px rgba(0, 0, 0, 0.1);
  width: 45%;
  padding: 22px 25px;
  position: absolute;
  right: -35px;
  top: -25px;
}

.have {
  padding-top: 80px;
  padding-bottom: 80px;
  background-color: #000;
}

.lead-eng1 h6 span {
  color: #848484;
}

.lead-eng1 {
  background: #ffffff;
  box-shadow: 0px 9px 40px -10px rgba(0, 0, 0, 0.1);
  width: 45%;
  padding: 22px 25px;
  position: absolute;
  right: -70px;
  bottom: 20px;
}

.lead-eng1 h6 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  margin-bottom: 0px;
  padding-top: 7px;
}

/* .have-left:before {
  content: '';
  background: #1F4572;
  box-shadow: 0px 19.0574px 35.5738px rgba(86, 73, 206, 0.19);
  width: 155px;
  height: 155px;
  position: absolute;
  border-radius: 50%;
  top: -40px;
  left: -15px;
}

.have-left:after {
  content: '';
  background-image: url(../images/vouch-icon.png);
  width: 22%;
  height: 40%;
  position: absolute;
  bottom: -20px;
  left: 25px;
  background-repeat: no-repeat;
} */

/* .have-right {
  padding-top: 50px;
} */

.btn-add i {
  color: #3cb265;
  font-size: 15px;
  text-align: center;
}

.btn-add {
  background-color: rgb(60 178 101 / 60%);
  width: 30px;
  height: 30px;
  padding: 3px 9px;
  border-radius: 50%;
  margin-right: 20px;
}

.start {
  padding-top: 60px;
  padding-bottom: 60px;
}

.start-left h3 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 40px;
  line-height: 50px;
  color: #202020;
}

.start-left p {
  color: #565656;
  margin-bottom: 22px;
}

.start-left {
  padding-top: 80px;
}

.lead-box {
  /* background-color: #F9F9F9; */
  padding: 35px 25px;
  padding-top: 0px;
  text-align: center;
  /* margin-top: 20px; */
  transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
}
.lead-box img {
  width: 80%;
}

.lead-box h6 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 18px;
  color: #ffffff;
  background-color: #1f4572;
  width: 50px;
  height: 50px;
  text-align: center;
  padding: 17px 14px;
  margin: 0 auto 20px;
  border-radius: 50%;
}

.lead-box h5 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 18px;
  color: #202020;
  margin-bottom: 4px;
  margin-top: 25px;
}

.lead-box p {
  color: #565656;
}

.lead-market h3 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 40px;
  line-height: 50px;
  color: #202020;
  text-align: center;
  padding: 0px 305px;
  margin-bottom: 55px;
}
.lead-market p {
  text-align: center;
  color: #565656;
}

.lead-market {
  padding-top: 60px;
  background-color: #f1f1f1;
  padding-bottom: 60px;
}

.bgn-now {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 18px;
  color: #55b56d;
  border: 1px solid #55b56d;
  transition: 0.5s;
  padding: 12px 25px;
  display: inline-block;
  width: 236px;
  margin: 20px auto 0px;
  border-radius: 5px;
}

.need h3 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 40px;
  line-height: 50px;
  text-align: left;
  color: #fff;
  margin-bottom: 4px;
}

.need-inner-right ul {
  padding: 0px;
  margin: 0px;
  display: inline-block;
  margin-bottom: 20px;
}

.need-inner-right ul li {
  float: left;
  width: 100%;
  margin-top: 15px;
}

.need-inner-right ul li img {
  width: 6%;
  float: left;
  margin-right: 12px;
}

.need-inner-right ul li h5 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #fff;
}

.need-inner-right .btn-lead {
  width: 139px;
  margin: 0 auto;
  display: flex;
  border-color: #55b56d;
  color: #fff;
  background-color: #55b56d;
}
.need-inner-right {
  padding-left: 25px;
}
.have-right .btn-lead {
  border-color: #fff;
  color: #fff;
}

.need {
  padding-top: 60px;
  background-color: #000000;
}

.with {
  padding: 50px 0px;
  background-repeat: no-repeat;
  height: 100%;
  background-size: cover;
}

.with-left h5 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 26px;
  line-height: 35px;
  padding-right: 35px;
  color: #ffffff;
  margin-bottom: 0px;
}
.with-left h3 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 40px;
  line-height: 50px;
  color: #202020;
  text-align: center;
  padding: 0px 305px;
  margin-bottom: 4px;
}

.with-left h4 {
  margin-bottom: 15px;
}

.with-left p {
  padding: 0px 89px;
}

.looking-main-left {
  width: 26%;
}

.looking-main-right {
  width: 26%;
}

.looking-main {
  justify-content: center;
  margin: 15px 0px;
}
.looking-main h5 {
  color: #55b56d;
}

.with-left {
  text-align: center;
}

.looking-main-right select {
  border: 2px solid #2f92f2;
  border-radius: 0px;
  width: 85%;
  height: 45px;
  font-weight: 600;
  font-size: 18px;
  line-height: 26px;
  color: #2f92f2;
}

.learn-20 h2 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 50px;
  line-height: 50px;
  margin-bottom: 2px;
  color: #ffffff;
}

.learn-20 p {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  color: #dadada;
  margin-bottom: 0px;
}

.btn-lrnbl {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 22px;
  color: #1f4572;
  background-color: #ffffff;
  padding: 12px 95px;
  display: inline-block;
  margin-top: 50px;
  border: 1px solid #fff;
}

:hover.btn-lrnbl {
  background-color: unset;
  color: #fff;
}

.with .row {
  padding: 0px 110px;
}

.learn-20 {
  width: 200px;
}

.with-right {
  padding-left: 15px;
}

.learn-box {
  position: relative;
}

.learn-box:after {
  content: "";
  border-top: 2px solid #ffff;
  position: absolute;
  left: 0px;
  top: -30px;
  width: 86.7%;
}

.testimonials h3 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 40px;
  line-height: 50px;
  text-align: center;
  color: #202020;
}

.testimonials p {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #565656;
  padding: 1px 283px;
  text-align: center;
  margin-bottom: 30px;
}

.testimonials .swiper {
  width: 100%;
  height: 100%;
}

.testimonials .swiper-button-next:after,
.testimonials .swiper-button-prev:after {
  font-size: 16px;
  background-color: #55b56d;
  padding: 9px 12px;
  border-radius: 0px;
  color: #fff;
  text-align: center;
}

.testimonials .swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.testimonials .swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.testimonials .swiper {
  margin-left: auto;
  margin-right: auto;
}

/* .testimonials-box {
  background-color: #f9f9f9;
  padding: 55px 60px;
} */
.testimonials-box {
  min-height: 250px;
  background-color: #f9f9f9;
  padding: 25px 25px;
  margin: 0px 10px;
}

.testimonials {
  padding-top: 75px;
  padding-bottom: 75px;
}

.testimonials-box-left h4 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 38px;
  line-height: 42px;
  text-align: left;
  margin-bottom: 0px;
  padding-right: 90px;
  color: #55b56d;
}

.testimonials-box-right p {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 30px;
  text-align: left;
  padding: 0px;
}

.testimonials .swiper-horizontal {
  padding: 0px 60px;
}

.king-box img {
  width: 50px !important;
  float: left;
  margin-right: 20px;
}

.king-box h5 {
  text-align: left;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 2px;
  color: #55b56d;
}

.king-box h6 {
  text-align: left;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 24px;
  color: #3c3c3c;
}

/**blog**/
.blog-banner {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  width: 100%;
  height: 410px;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
}

.latest-title h3 {
  color: #3b3d4c;
  margin-bottom: 30px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 28.5504px;
  line-height: 43px;
}

.latest-article img {
  width: 100%;
  margin-bottom: 10px;
}

.latest-article h3 {
  color: #3b3d4c;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 25.4914px;
  line-height: 32px;
}

.latest-article p {
  color: #3b3d4c;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 16.3145px;
  line-height: 22px;
  margin-bottom: 25px;
  padding-right: 10px;
}

.reads-latest a {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 30px;
  color: #55b56d;
  border: 1px solid #55b56d;
  padding: 6px 26px;
  display: inline-block;
  margin-bottom: 45px;
}

.universities.latest {
  padding: 55px 0px;
}

.input-group.serach-btn {
  background: #55b56d;
  width: 260px;
  height: 44px;
}

.input-group.serach-btn input.form-control {
  background-color: unset;
  border-color: #55b56d;
}

.input-group.serach-btn span#basic-addon2 {
  background-color: unset;
  border-color: #55b56d;
}

.input-group.serach-btn span#basic-addon2 i {
  color: #fff;
  font-weight: 300;
}

.categories h3 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 22.573px;
  line-height: 34px;
  color: #202020;
  margin-bottom: 20px;
}

.categories h3:after {
  content: "";
  width: 45px;
  position: absolute;
  top: 35px;
  left: 0px;
  height: 3px;
  background-color: #55b56d;
}

.categories ul {
  padding: 0px;
  margin: 0px;
  margin-bottom: 35px;
}

.categories ul li {
  list-style: none;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 275;
  font-size: 15.3496px;
  line-height: 45px;
  color: #202020;
  border-bottom: 1px solid #55b56d;
}

.categories ul li span {
  float: right;
}

.recent-blog h3 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 22.573px;
  line-height: 34px;
  color: #202020;
  margin-bottom: 35px;
}

.recent-blog h3:after {
  content: "";
  width: 45px;
  position: absolute;
  top: 35px;
  left: 0px;
  height: 3px;
  background-color: #55b56d;
}
.recent-blog-left img {
  width: 100%;
}
.recent-blog-left {
  margin-bottom: 20px;
}

.recent-blog-right h5 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 275;
  font-size: 14px;
  line-height: 21px;
  color: #3b3d4c;
}

.recent-blog-right h4 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #202020;
  margin-bottom: 12px;
}

.tags h3 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 22.573px;
  line-height: 34px;
  color: #202020;
  margin-bottom: 35px;
}

.tags h3:after {
  content: "";
  width: 45px;
  position: absolute;
  top: 35px;
  left: 0px;
  height: 3px;
  background-color: #55b56d;
}

.tags ul {
  padding: 0px;
  margin: 0px;
}

.tags ul li {
  list-style: none;
  float: left;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 300;
  font-size: 13px;
  line-height: 20px;
  margin-right: 8px;
  margin-bottom: 14px;
}

.tags ul li a {
  color: #fff;
  background: #55b56d;
  padding: 6px 12px;
  text-decoration: none;
}

.input-group.serach-btn input.form-control::placeholder {
  color: #fff;
}

.reads-latest:hover a {
  background-color: #55b56d;
  color: #fff;
}

.reads-latest {
  width: 156px;
}

.blog-banners {
  width: 46%;
  padding-left: 105px;
  padding-top: 68px;
  position: relative;
  z-index: 10;
}

.blog-banners h2 {
  color: #ffffff;
  position: relative;
  z-index: 1;
  margin-bottom: 25px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 52.6882px;
  line-height: 66px;
}

.btn-blg {
  background-color: #55b56d;
  border: 1px solid #55b56d;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 30px;
  color: #fff;
  padding: 5px 25px;
  display: inline-block;
}

/**footer**/
.footer-top {
  padding: 75px 0px;
  padding-bottom: 20px;
  background-color: #000;
}

.footer-top-1 p {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #fff;
  padding-right: 65px;
  margin-bottom: 30px;
}

.footer-top-1 a img {
  width: 220px;
  margin-bottom: 20px;
}

.footer-top-1 h5 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  color: #000000;
  margin-bottom: 30px;
}

.socila-icon li a {
  color: #000000 !important;
  font-size: 15px;
  display: block;
}

.socila-icon {
  padding: 0px;
  margin: 0px;
}

.footer-top-2 h4 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: #55b56d;
  margin-top: 25px;
  margin-bottom: 15px;
}

.footer-top-2 ul {
  padding: 0px;
  margin: 0px;
}

.socila-icon li {
  border: 1px solid #fff;
  width: 35px;
  height: 35px;
  padding: 3px 10px;
  margin-right: 10px;
  border-radius: 14%;
  text-align: center;
  transition: 0.5s;
  background-color: #fff;
}

.socila-icon li:hover {
  background-color: #55b56d;
}

.footer-top-1 .input-group:hover #basic-addon2 {
  background-color: #1f4572;
  border-color: #1f4572;
}

.socila-icon li:hover a {
  color: #fff;
}

.footer-top-2 ul li a {
  color: #fff;
  transition: 0.5s;
}

.footer-top-1 .input-group {
  height: 45px;
  margin-top: 20px;
  width: 82%;
}

.footer-top-1 .input-group input {
  background-color: unset;
  border-color: #f9f9f9;
  border-radius: 0px;
  padding: 0px 18px;
  padding-bottom: 0px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 28px;
  color: #fff;
}

.footer-top-1 .input-group #basic-addon2 {
  background-color: #55b56d;
  border-color: #fff;
  color: #ffffff;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 131%;
  border-radius: 0px;
  padding: 0px 18px;
  margin-left: 0px;
  cursor: pointer;
  transition: 0.5s;
}

.footer-top-2 p {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #fff;
  padding-right: 18px;
  margin-top: 25px;
  margin-bottom: 30px;
}

.subrcb {
  padding-left: 50px;
}

.socila-icon li:nth-child(3) {
  padding: 2px 10px;
  padding-left: 11px;
}

.copy-content p {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #fff;
  margin-bottom: 0px;
}

.copy-box {
  width: 100%;
  padding-top: 50px;
}

.copy-content {
  width: 50%;
}

.footer-top-2 ul li {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
}

.footer-top-2 ul li:hover a {
  color: #55b56d;
}

.scroll-to-top {
  background-color: #55b56d;
  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
  border: none;
  border-radius: 50%;
  bottom: 53px;
  color: #fff;
  cursor: pointer;
  display: none;
  font-size: 22px;
  height: 50px;
  line-height: 50px;
  position: fixed;
  right: 20px;
  text-align: center;
  width: 50px;
  z-index: 100;
  transition: all 0.3s ease-in-out;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
}

.fixed-top {
  top: -40px;
  transform: translateY(40px);
  transition: transform 0.3s;
  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
}

.quick-form {
  flex-wrap: wrap;
  justify-content: space-around;
}

.form-grp {
  width: 48%;
}

.quick {
  padding: 55px 0px;
  background-color: #f9f9f9;
  background-color: #fff;
  border-radius: 10px;
  padding: 30px 20px;
}

.form-grp input {
  box-shadow: 0px 8px 41px -9px rgba(0, 0, 0, 0.09);
  background-color: #fdfdfd;
  border: 1px solid #ffff;
  height: 50px;
  border-radius: 0px;
}

.form-grp label {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
}
.form-grp .form-control[type="file"] {
  overflow: hidden;
  padding: 12px 10px;
  background-color: #e9ecef;
}
.form-grp input::placeholder {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 15px;
  color: #787272;
}

.form-grp input:focus {
  border-color: #55b56d;
}
.form-grp select:focus {
  box-shadow: none;
  border-color: #55b56d;
}
.form-grp select {
  box-shadow: 0px 8px 41px -9px rgba(0, 0, 0, 0.09);
  background-color: #fdfdfd;
  border: 1px solid #ffff;
  height: 50px;
  border-radius: 0px;
}

.btn-quick {
  background-color: #55b56d;
  border: 1px solid #55b56d;
  transition: 0.5s;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #f9f9f9;
  border-radius: 5px;
  padding: 6px 35px;
  display: block;
  padding-top: 8px;
  margin: 25px auto 0px;
  transition: 0.5s;
}

:hover.btn-quick {
  background-color: unset;
  color: #55b56d;
}

/**domainform**/
.annad-cnnt-lst {
  display: inline-block;
  padding-top: 12px;
}

.annad-cnnt-lst ul li {
  list-style: none;
  float: left;
  margin-right: 8px;
  margin-bottom: 12px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  line-height: 131%;
}

.annad-cnnt-lst .btn-outline-danger {
  color: #55b56d;
  border-color: #55b56d;
  background-color: unset;
  font-size: 14px;
  border-radius: 5px;
}

.btn-check:active + .btn-outline-danger,
.btn-check:checked + .btn-outline-danger,
.btn-outline-danger.active,
.btn-outline-danger.dropdown-toggle.show,
.btn-outline-danger:active {
  color: #fff;
  background-color: #55b56d;
  border-color: #55b56d;
}

.btn-check:active + .btn-outline-danger:focus,
.btn-check:checked + .btn-outline-danger:focus,
.btn-outline-danger.active:focus,
.btn-outline-danger.dropdown-toggle.show:focus,
.btn-outline-danger:active:focus {
  box-shadow: 0 0 0 0.25rem rgb(249 249 249);
}
.btn-check:focus + .btn-outline-danger,
.btn-outline-danger:focus {
  box-shadow: 0 0 0 0.25rem rgb(249 249 249);
}

.annad-cnnt-lst ul {
  padding: 0px;
  margin: 0px;
}

/*signup*/
.logine {
  border-radius: 25px;
  max-width: 550px;
  margin: 0 auto;
  padding: 20px 20px 0;
  border: 1px solid #e1dcdc;
  padding-bottom: 20px;
  background-color: #fff;
  box-shadow: 0 0 5px 1px #e2e2e2;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  justify-content: center;
}

.logine label {
  font-size: 15px;
  font-weight: 400;
  color: #212529;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;

  line-height: 28px;
}

.logine .form-control {
  height: 38px;
  border-radius: 14px;
}

.logine label {
  font-size: 14px;
  font-weight: 400;
  color: #212529;
}

.logine .form-control {
  height: 38px;
  border-radius: 14px;
}

.field-icon {
  float: right;
  margin-left: -25px;
  margin-top: -25px;
  position: relative;
  z-index: 2;
}

.btn.btre {
  padding: 7px 124px;
  background-color: #55b56d;
  border-color: #55b56d;
  margin-top: 25px;
  border-radius: 14px;
  width: 100%;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  transition: 0.5s;
}
.btn:hover.btre {
  background-color: unset;
  color: #55b56d;
}

.frg-btn h6 {
  text-align: center;
  margin: 10px 0px;
  color: #000000;
  cursor: none;
}

.sales-left {
  padding: 80px 0px;
  background-color: #f9f9f9;
}

.logine .form-group {
  width: 48%;
  margin: 0 auto 8px;
}

.logine .form-select {
  height: 38px;
  border-radius: 14px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
}

.logine .form-label {
  margin-bottom: 0px;
}

.logine h4 {
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
  font-size: 25px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
}

a.frg-btn {
  clear: both;
  width: 100%;
}

.logine ul li {
  float: left;
  /* margin-right: 13px; */
  text-align: center;
  width: 33%;
}

.logine ul {
  padding: 0px;
  margin: 0px;
  display: inline;
  width: 16%;
}

.logine ul li a i.fa.fa-facebook {
  color: #3b5998;
}
.logine ul li a i.fa.fa-google-plus {
  color: #db4a39;
}
.logine ul li a i.fa.fa-linkedin {
  color: #0072b1;
}

/*blogdetail*/

.universities-left h2 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 35px;
  line-height: 52px;
  color: #000;
}

.universities-left ul li {
  list-style: none;
  float: left;
  margin-right: 20px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
}

.universities-left ul li a {
  color: #000000;
  text-decoration: none;
}

.universities-left ul li a i {
  margin-right: 5px;
  color: #55b56d;
}

.btn-sbmt {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 131%;
  color: #ffffff;
  background-color: #55b56d;
  border: 1px solid #55b56d;
  transition: 0.5s;
  padding: 10px 28px;
  border-radius: 5px;
  margin-top: 20px;
}

.whatp ul li {
  float: inherit;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: #000000;
}

.universities-left ul {
  margin: 0px;
  padding: 0px;
  margin-bottom: 8px;
  display: inline-block;
}
.universities-left img {
  width: 100%;
  margin-bottom: 20px;
}

/**news**/
.fireside-main img {
  width: 48%;
  margin-right: 14px;
}

.fireside-main-rigth {
  width: 50%;
}

.fireside {
  background-color: #f9f9f9;
  padding: 55px 0px;
}

.fireside h3 {
  font-size: 25px;
  font-family: "Poppins";
  margin-bottom: 25px;
}

.fireside-main-rigth h4 {
  font-size: 18px;
  line-height: 22px;
  text-align: justify;
  font-family: "Poppins";
  margin-bottom: 12px;
}

.fireside-main-rigth p {
  text-align: justify;
}

/**contact**/
.form-grp textarea.form-control {
  box-shadow: 0px 8px 41px -9px rgba(0, 0, 0, 0.09);
  background-color: #fdfdfd;
  border: 1px solid #ffff;

  border-radius: 0px;
}

.quick h3 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 40px;
  line-height: 50px;
  color: #202020;
  text-align: center;
  margin-bottom: 35px;
}

.austrial h3 {
  font-size: 25px;
  font-family: "Poppins";
  color: #55b56d;
  font-weight: 500;
  margin-bottom: 18px;
  margin-top: 10px;
}

.austrial ul li {
  margin-bottom: 25px;
}

.austrial ul li a {
  color: #7a7a7a;
  font-size: 14px;
  line-height: 22px;
  font-family: "Poppins";
  text-decoration: none;
}

.austrial ul li a i {
  font-size: 13px;
  margin-right: 15px;
  border: 1px solid #333;
  width: 24px;
  height: 24px;
  text-align: center;
  line-height: 22px;
  color: #55b56d;
}

.austrial {
  border: 1px solid #eaeaea;
  padding: 45px 35px;
  margin-bottom: 15px;
}

.austrial ul {
  padding: 0px;
  margin: 0px;
  display: inline-block;
}

.mapse {
  padding: 55px 0px;
}
/*privacy*/
.privacy-main h3 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 40px;
  line-height: 50px;
  color: #202020;
  text-align: center;
  margin-bottom: 35px;
}

.privacy-main {
  padding: 55px 0px;
}

.privacy-inner h4 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 32px;
  color: #202020;
  margin-top: 15px;
}

/*award*/
.promoting h3 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 40px;
  line-height: 50px;
  color: #202020;
  text-align: center;
  margin-bottom: 10px;
}

.promoting {
  padding: 50px 0px;
}

.promoting a img {
  margin-bottom: 25px;
}

.promoting p {
  text-align: center;
  margin-bottom: 25px;
  padding: 0px 220px;
}

.research {
  background-color: #f9f9f9;
  padding: 55px 0px;
}

.research-box ul {
  padding: 0px;
  margin: 0px;
}

.research-box ul li img {
  width: 9%;
  margin-right: 8px;
}

.research-box {
  box-shadow: 0px 8px 41px -9px rgba(0, 0, 0, 0.09);
  background-color: #fdfdfd;
  border: 1px solid #ffff;
  padding: 45px 20px;
}

.research-box ul li {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 38px;
}

.research-box h5 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 18px;
  color: #202020;
  margin-bottom: 12px;
  margin: 15px 0px;
  text-align: center;
  margin-top: 25px;
}

.icon-featured {
  background-color: #55b56d;
}

.icon-featured {
  display: inline-block;
  font-size: 0;
  margin: 15px;
  width: 110px;
  height: 110px;
  border-radius: 50%;
  text-align: center;
  position: relative;
  z-index: 1;
  color: #fff;
  font-size: 2.3em;
  line-height: 110px;
  margin: 0 auto;
  display: block;
}

/*testimonials*/
.client {
  width: 100%;
  height: 100%;
  background: #f9f9f9;
}

.carousel-icon i {
  font-size: 5rem;
  color: rgba(255, 255, 255, 0.3);
  color: #000;
}

.carousel-item i {
  font-size: 1.6rem;
  color: rgba(255, 255, 255, 0.3);
  color: #000;
}

.t-card {
  padding: 1.8125rem 1.125rem;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 1.25rem;
  color: #fff;
  height: auto;
  box-shadow: 0px 8px 41px -9px rgba(0, 0, 0, 0.09);
  background-color: #fff;
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 1.5625rem solid transparent;
  border-right: 1.5625rem solid transparent;
  border-top: 1.25rem solid rgba(0, 0, 0, 0.5);
  border-top: 1.25rem solid rgb(255 255 255);
}

.client h1 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 40px;
  line-height: 50px;
  color: #202020;
  text-align: center;
}

.btn-outline-light {
  color: #55b56d !important;
  border: 1px solid #333;
}

.client h4 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 18px;
  color: #202020;
}

.testimonial_subtitle {
  color: #3b3d4c;
}

.t-card p {
  color: #3b3d4c;
}
/**lead**/

.gj-datepicker-bootstrap button[role="right-icon"] .gj-icon,
.gj-datepicker-bootstrap button[role="right-icon"] .material-icons {
  position: absolute;
  font-size: 21px;
  top: 15px;
  left: 0.55rem;
}

/*exam*/
.questionpaper {
  padding: 50px 0px;
}
.questionpaper-cnt ul {
  padding: 0px;
  margin: 0px;
  border-bottom: 1px solid #333;
  padding-bottom: 18px;
}
.questionpaper-cnt ul li {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 180%;
  color: #000000;
  list-style: none;
  text-align: left;
}

.questionpaper-cnt h5 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 19px;
  line-height: 140.5%;
  color: #000000;
  margin-bottom: 10px;
}

.questionpaper-cnt h4 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 160.5%;
  color: rgba(0, 0, 0, 0.66);
  margin-bottom: 0px;
  margin-top: 22px;
  text-align: justify;
}

.questionpaper h3 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 35px;
  line-height: 140.5%;
  color: #000000;
  text-align: center;
}
.questionpaper-cnt ul h2 {
  font-size: 25px;
  text-align: center;
  margin: 10px 0px;
  font-weight: 700;
}

/* .questionpaper .row {
  padding: 0px 40px;
} */
.questionpaper-cnt h3 {
  font-size: 22px;
  margin-bottom: 0px;
  margin-top: 20px;
}

/**Subscriptions***/

.pricing-card {
  border: none;
  border-radius: 4px;
  margin-bottom: 28px;
  transition: all 0.6s;
}

.pricing-card .card-header {
  background-color: #55b56d;
  color: #fff;
  padding-top: 40px;
  padding-bottom: 36px;
}

.pricing-plan-title {
  font-size: 20px;
  color: inherit;
  margin-bottom: 0;
  font-weight: normal;
}

.pricing-plan-cost {
  font-size: 28px;
  font-weight: bold;
}
.pricing-card .card-body {
  padding: 22px 35px 27px;
}
.pricing-plan-features {
  list-style: none;
  padding-left: 0;
  color: #303132;
  font-size: 14px;
  line-height: 2.86;
  margin-bottom: 16px;
}
.pricing-plan-features li {
  border-bottom: 1px solid #e3e3e3;
}

.pricing-plan-purchase-btn {
  color: #fff;
  background-color: #55b56d;
  border-color: #55b56d;
  font-size: 14px;
  font-weight: bold;
  padding: 13px 20px;
  border-radius: 6px;
  transition: all 0.4s;
  position: relative;
}

.subscriptions h4 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 40px;
  line-height: 50px;
  color: #202020;
  text-align: center;
  margin-bottom: 35px;
}

.subscriptions {
  padding: 55px 0px;
}

/**memberdetails**/
.ourmembers-inner img {
  width: 18%;
}
.ourmembers-inner h6 {
  text-align: center;
  color: #565656;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
}

.ourmembers-inner p {
  text-align: center;
  color: #565656;
}

.ourmembers-inner ul {
  padding: 0px;
  margin: 0px;
  display: inline-block;
}

.ourmembers-inner ul li {
  list-style: none;
  float: left;
  margin-right: 10px;
  background-color: #55b56d;
  width: 35px;
  height: 35px;
  border-radius: 5px;
  padding: 5px 10px;
  text-align: center;
  border: 1px solid #55b56d;
}
.ourmembers-inner ul li a {
  color: #fff;
}

.ourmembers-inner {
  background-color: #fff;
  box-shadow: 0px 8px 41px -9px rgba(0, 0, 0, 0.09);
  padding: 40px 40px;
  margin: 0px 170px;
  text-align: center;
}

.ourmembers-inner h5 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 18px;
  color: #202020;
  margin-bottom: 4px;
  margin-top: 25px;
}

/*faq*/

/* Custom style */
.accordion-button::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  transform: scale(0.7) !important;
}
.accordion-button:not(.collapsed)::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.faqs {
  padding: 55px 0px;
}
.faqs .accordion-item {
  border: none;
}

.faqs .accordion-button:not(.collapsed) {
  background-color: #55b56d;
  color: #fff;
}
.faqs .accordion-button:not(.collapsed)::after {
  filter: invert(1);
}

.faqs .card-body {
  background-color: #f2efef;
  padding: 1%;
}

.faqs h3 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 40px;
  line-height: 50px;
  color: #000;
  text-align: center;
  margin-bottom: 35px;
}

.faqs .accordion-button {
  font-family: "Poppins";
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 18px;
  color: #202020;
  background-color: #f2efef;
  margin-top: 10px;
}

.faqs .accordion-item:first-of-type .accordion-button {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}

.faqs .card-body p {
  font-size: 16px;
  line-height: 26px;
}

.faqs .accordion-button:focus {
  box-shadow: none;
}

/*joblists*/
.joblist {
  background-color: #000;
  padding: 50px 0px;
}

.joblist-inner ul {
  padding: 0px;
  margin: 0px;
  display: inline-block;
}

.joblist-inner ul li {
  list-style: none;
  float: left;
  width: 100%;
  font-family: "Poppins";
  font-size: 15px;
  line-height: 26px;
  color: #fff;
  text-align: center;
}

.joblist-inner {
  box-shadow: 0px 8px 41px -9px rgba(0, 0, 0, 0.09);
  background-color: #000;
  padding: 30px 25px;
  margin-bottom: 25px;
  border: 1px solid grey;
}

.joblist h3 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 40px;
  line-height: 50px;
  color: #fff;
  text-align: center;
  margin-bottom: 35px;
}

.joblist h4 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 24px;
  color: #55b56d;
  margin-bottom: 12px;
  text-align: center;
}

.aply-contact form .form-group {
  margin-bottom: 15px;
}

.aply-contact form .form-group .message-field {
  border: 1px solid #000;
  width: 100%;
  border-radius: 6px;
  padding-left: 10px;
  padding-top: 10px;
}

.aply-contact form .form-group .form-control {
  height: 38px;
  border: 1px solid #000;
  border-radius: 6px;
}

.apply-btn {
  font-size: 16px;
  border: 1px solid #55b56d;
  border-radius: 5px;
  padding: 6px 20px;
  background-color: #55b56d;
  color: #fff;
}

.aply-btn {
  background-color: #55b56d;
  border-color: #55b56d;
  border-radius: 5px;
  padding: 8px 20px;
  width: 130px;
  margin: 20px auto 0px;
  display: block;
}

.joblist-inner ul li i {
  margin-right: 10px;
}

.joblist-inner img {
  width: 55px;
  margin: 0 auto;
  display: block;
}
/**partner**/
.brand {
  /* background-color: #000; */
  padding: 55px 0px;
  /* margin-bottom: 60px; */
}

.brand-inner img {
  width: 100%;
  text-align: center;
}

.brand .col {
  border-right: 1px dotted #000;
  border-bottom: 1px dotted #000;
  padding: 20px;
}

.brand .col:nth-child(6),
.brand .col:nth-child(12),
.brand .col:nth-child(18),
.brand .col:nth-child(24),
.brand .col:nth-child(30),
.brand .col:nth-child(36) {
  border-right: none;
}

.brand .col:nth-child(25),
.brand .col:nth-child(26),
.brand .col:nth-child(27),
.brand .col:nth-child(28),
.brand .col:nth-child(29),
.brand .col:nth-child(30) {
  border-bottom: none;
}

.brand h3 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 40px;
  line-height: 50px;
  text-align: center;
  color: #202020;
  margin-bottom: 35px;
}

.brand .carousel-item img {
  border: 1px solid grey;
  height: 70px;
  padding: 12px 10px;
}

/**event**/
.testimonialss .testimonials-box-left {
  width: 48%;
  display: flex;
  margin: 0 auto;
}

.testimonialss .testimonials-box-right {
  width: 48%;
  display: flex;
  margin: 0 auto;
}

.testimonialss .testimonials-box-left img {
  width: 50%;
}
.testimonialss .testimonials-box-right img {
  width: 50%;
}

.testimonialss .swiper-horizontal {
  background-color: #000;
}
.testimonials .swiper-slide {
  background-color: unset;
}

.testimonialss .testimonials-box {
  background-color: unset !important;
  padding: 55px 0px;
}

.testimonialss {
  background-color: #000;
}

.testimonialss h3 {
  color: #fff;
  margin-bottom: 30px;
}

.tech-box h5 {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #55b56d;
  margin-bottom: 4px;
  text-align: left;
}

.tech-box h6 {
  font-size: 15px;
  color: #fff;
  font-family: "Poppins";
  text-align: left;
  margin-bottom: 0px;
  margin-top: 12px;
}

.tech-box {
  padding: 25px 20px;
}

.btn-dtl {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 18px;
  border: 1px solid #55b56d;
  transition: 0.5s;
  padding: 8px 18px;
  background-color: #55b56d;
  color: #000;
  margin-top: 20px;
  display: inline-block;
}

.need-inner-right p {
  color: #fff;
  text-align: justify;
}

.src-loctaion .input-group {
  width: 100%;
  justify-content: space-around;
}

.src-loctaion .form-group {
  width: 89%;
}

.src-loctaion select {
  border-radius: 5px 0px 0px 5px;
}

.lrpTableR td:nth-child(1){
  width: 28%;
}

.lrpTableR td{
  text-align: left !important;
  vertical-align: top;
  font-size: 0.9rem;
}

.lrpTableR td ul li{
  font-size: 0.9rem;
  font-weight: 500;
}

.lrpCircle{
  padding-left: 20px;
  padding-bottom: 10px;
}

.lrpCircle li{
  font-size: 0.9rem;
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/main.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;GACG,gBAAgB;AACnB;;AAEA;EACE,iBAAiB;AACnB;AACA;AACA,iBAAiB;AACjB,WAAW;AACX,oBAAoB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;AACA,WAAW;AACX,aAAa;AACb,kBAAkB;AAClB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,UAAU;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,2BAA2B;EAC3B,wFAAwF;CACzF;;CAEA;EACC,sBAAsB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;CACtB;;CAEA;EACC,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;EACnB;;;;;AAKF;EACE,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iDAAiD;EACjD,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;AACA;EACE,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE;AACF;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;;AAEA;;GAEG;;AAEH;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;GAEG;;AAEH;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;;GAEG;;AAEH;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iDAAiD;EACjD,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;EAC5C,mCAA2B;UAA3B,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,WAAW;EACX,6BAA6B;EAC7B,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;AAOA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;EAEE,qCAAqC;EACrC,+BAA+B;EAC/B,kCAAkC;EAClC,aAAa;EACb,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kDAAkD;EAClD,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mDAAmD;EACnD,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mDAAmD;EACnD,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yDAA8C;EAC9C,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;;;;;;GAOG;;AAEH;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iDAAiD;EACjD,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iDAAiD;EACjD,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;;;;;;GAqBG;;AAEH;;GAEG;;AAEH;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,gCAAgC;EAChC,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;AACrC;AACA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;GAGG;AACH;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,yDAA+C;EAC/C,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,8EAA8E;EAC9E,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;EACb,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,0BAA0B;EAC1B,8EAA8E;AAChF;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iDAAiD;EACjD,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,iDAAiD;EACjD,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;;;EAKE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;;EAKE,0CAA0C;AAC5C;AACA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,SAAS;AACT;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,oBAAoB;EACpB,sBAAsB;EACtB,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;;EAEhB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,aAAa;;AAEb;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,iDAAiD;EACjD,yBAAyB;EACzB,uBAAuB;;EAEvB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;AACA,UAAU;AACV;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,QAAQ;AACR;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,iDAAiD;EACjD,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,iDAAiD;EACjD,sBAAsB;AACxB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,wCAAwC;EACxC,yCAAyC;EACzC,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA,SAAS;;AAET;;EAEE,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,aAAa;AACf;;AAEA,OAAO;AACP;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;GAEG;AACH;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,mBAAmB;;AAEnB;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EAEnB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAElB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,iDAAiD;EACjD,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,MAAM;;AAEN,iBAAiB;AACjB;EACE,yDAAuR;EACvR,gCAAgC;AAClC;AACA;EACE,yDAAgP;AAClP;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iDAAiD;EACjD,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,cAAc;AAChB;AACA,YAAY;AACZ;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,aAAa;AACf;;AAEA;;;;;;EAME,kBAAkB;AACpB;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,UAAU;EACV,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":["* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n  list-style: none;\r\n}\r\n\r\na {\r\n  text-decoration: none;\r\n}\r\n\r\n.activeLeads {\r\n   background: #000;\r\n}\r\n\r\nsection.activeLeads{\r\n  padding: 60px 0px;\r\n}\r\nsection.activeLeads h3 {\r\nfont-size: 2.2rem;\r\ncolor: #fff;\r\npadding-bottom: 15px;\r\n}\r\nsection.activeLeads p {\r\n  color: #fff;\r\n}\r\n.aLeadImg{\r\n  width: 90% !important;\r\n}\r\n\r\nsection.intendData {\r\n  padding: 60px 0px;\r\n}\r\nsection.intendData h3 {\r\n  font-size: 2.2rem;\r\n  padding-bottom: 15px;\r\n}\r\n\r\n.campaignLink{\r\n\r\n  color: #fff;\r\n  padding: 10px 0px;\r\n}\r\n.arrWImg{\r\n  width: 30px !important;\r\n}\r\n\r\nsection.insights{\r\n  padding: 60px 0px;\r\n}\r\n\r\nsection.insights .imgWrap{\r\nwidth: 100%;\r\nheight: 350px;\r\nposition: relative;\r\n}\r\n\r\nsection.insights .imgWrap img.insightBI{\r\n width: 100%;\r\n height: 100%;\r\n position: absolute;\r\n top: 0px;\r\n left: 0px;\r\n z-index: 1;\r\n}\r\n\r\nsection.insights .imgWrap .coverTG{\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 20px;\r\n  position: absolute;\r\n  top: 0px;\r\n  left: 0px;\r\n  z-index: 2;\r\n  background: rgb(85,181,109);\r\n  background: linear-gradient(180deg, rgba(85,181,109,0.85) 0%, rgba(8,117,166,0.85) 100%);\r\n }\r\n\r\n section.insights h3{\r\n  font-family: \"Poppins\";\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    font-size: 40px;\r\n    line-height: 50px;\r\n    text-align: center;\r\n    color: #202020;\r\n    margin-bottom: 35px;\r\n }\r\n\r\n section.insights h5 {\r\n  font-size: 1.2rem;\r\n  font-weight: 400;\r\n  color: #fff;\r\n  padding-bottom: 15px;\r\n  }\r\n  section.insights p {\r\n    font-size: 1.4rem;\r\n    font-weight: 600;\r\n    color: #fff;\r\n    line-height: 35px;;\r\n  }\r\n\r\n\r\n\r\n\r\n.ultimate {\r\n  background-color: #000;\r\n  padding: 60px 0px;\r\n  padding-top: 75px;\r\n}\r\n\r\n.ultimate-inner p {\r\n  margin-bottom: 0px;\r\n  font-size: 1rem;\r\n  color: #fff;\r\n}\r\n\r\n.cmtMinH{\r\n  min-height: 850px;\r\n}\r\n\r\n.cmtMinH2{\r\n  min-height: 920px;\r\n}\r\n\r\n.ultimate-inner {\r\n  box-shadow: 0px 8px 41px -9px rgba(0, 0, 0, 0.09);\r\n  background-color: #000;\r\n  padding: 30px 25px;\r\n  margin-bottom: 25px;\r\n  border: 1px solid grey;\r\n}\r\n\r\n.ultimate-inner img {\r\n  width: 65px;\r\n  /* margin-bottom: 12px; */\r\n}\r\n.ultimate-inner h5 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  font-size: 1.2rem;\r\n  line-height: 28px;\r\n  color: #55b56d;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.ultimate h3 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 40px;\r\n  line-height: 50px;\r\n  color: #fff;\r\n  text-align: center;\r\n  margin-bottom: 35px;\r\n}\r\n\r\n.maine-header .navbar-brand img {\r\n  width: 90%;\r\n}\r\n\r\nul.mrkts {\r\n  margin: 0px;\r\n  padding: 0px;\r\n  display: inline-block;\r\n  padding-left: 17px;\r\n}\r\n\r\nul.mrkts li {\r\n  list-style: none;\r\n  float: left;\r\n  width: 33%;\r\n  font-size: 13px;\r\n  color: #fff;\r\n  font-family: \"Poppins\";\r\n  margin-bottom: 6px;\r\n  line-height: 18px;\r\n  text-align: left;\r\n  height: 36px;\r\n  list-style-type: disc;\r\n}\r\n\r\n.profile-jobs img {\r\n  width: 65% !important;\r\n  margin: 0 auto;\r\n  display: block;\r\n}\r\n.profile-jobs {\r\n  padding: 0px 70px;\r\n}\r\n\r\n.profile-jobs h5 {\r\n  text-align: center !important;\r\n  margin-top: 15px;\r\n  margin-bottom: 3px;\r\n}\r\n\r\n.profile-jobs h6 {\r\n  color: #fff;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n}\r\n\r\n.ourmembers h3 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 40px;\r\n  line-height: 50px;\r\n  color: #202020;\r\n  text-align: center;\r\n  margin-bottom: 35px;\r\n}\r\n\r\n.ourmembers {\r\n  padding: 45px 0px;\r\n  background-color: #f9f9f9;\r\n}\r\n\r\n.maine-banner-inner ul {\r\n  padding: 0px;\r\n  margin: 0px;\r\n  flex-wrap: wrap;\r\n}\r\n.maine-banner-inner ul li {\r\n  width: 50%;\r\n  line-height: 36px;\r\n}\r\n.maine-banner-inner ul li img {\r\n  width: 7%;\r\n  margin-right: 12px;\r\n}\r\n\r\n/*.maine-header .navbar-brand {\r\n padding:0px; \r\n}*/\r\n.form-control:focus {\r\n  box-shadow: none;\r\n}\r\np {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 16px;\r\n  line-height: 24px;\r\n}\r\n\r\nimg {\r\n  width: 100%;\r\n}\r\n\r\n.start-right img {\r\n  width: 39%;\r\n  margin: 0 auto;\r\n  display: block;\r\n}\r\n\r\n.start-right {\r\n  padding: 50px 50px;\r\n  text-align: center;\r\n}\r\n\r\n.container {\r\n  padding-left: 0px;\r\n  padding-right: 0px;\r\n}\r\n.maine-header {\r\n  background-color: #fff;\r\n}\r\n\r\n/* .lead-menu .navbar-brand img {\r\n  width: 175px;\r\n} */\r\n\r\n.lead-menu {\r\n  padding: 0;\r\n}\r\n\r\n.lead-menu .navbar-nav {\r\n  width: 89%;\r\n}\r\n\r\n.lead-menu .navbar-nav .nav-link {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n  line-height: 18px;\r\n  color: #000000;\r\n  padding: 25px 10px;\r\n  display: block;\r\n}\r\n\r\n.lead-menu .navbar-nav .nav-link.active {\r\n  color: #55b56d;\r\n}\r\n\r\n.lead-menu .navbar-nav > :hover .nav-link {\r\n  color: #55b56d;\r\n}\r\n\r\n.btn-login {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n  line-height: 18px;\r\n  color: #000000;\r\n  padding: 15px 30px;\r\n}\r\n\r\n.btn-sign {\r\n  background-color: #55b56d;\r\n  border: 1px solid #55b56d;\r\n  transition: 0.5s;\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 18px;\r\n  line-height: 18px;\r\n  color: #f9f9f9;\r\n  border-radius: 0px;\r\n  padding: 9px 19px;\r\n  height: 40px;\r\n  margin-top: 4px;\r\n}\r\n.btn-after {\r\n  background-color: #55b56d;\r\n  border: 1px solid #55b56d;\r\n  transition: 0.5s;\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 18px;\r\n  line-height: 18px;\r\n  color: #f9f9f9;\r\n  border-radius: 0px;\r\n  padding: 10px 19px;\r\n  margin-top: 4px;\r\n}\r\n\r\n:hover.btn-after {\r\n  background-color: unset;\r\n  color: #55b56d;\r\n  border-color: #55b56d;\r\n}\r\n\r\n.lead-box ul {\r\n  padding: 0px;\r\n  margin: 0px;\r\n  display: inline-block;\r\n}\r\n\r\n.lead-box ul li {\r\n  list-style: none;\r\n  float: left;\r\n  margin-right: 10px;\r\n  background-color: #55b56d;\r\n  width: 35px;\r\n  height: 35px;\r\n  border-radius: 5px;\r\n  padding: 5px 10px;\r\n  text-align: center;\r\n  border: 1px solid #55b56d;\r\n}\r\n\r\n.lead-box ul li a {\r\n  color: #fff;\r\n}\r\n\r\n.maine-banner {\r\n  background-color: #ffffff;\r\n  padding: 60px 0px;\r\n}\r\n.maine-banner-inner {\r\n  padding: 0px 0px;\r\n  padding-top: 20px;\r\n}\r\n\r\n/* :hover.lead-box {\r\n  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.2);\r\n} */\r\n\r\n.maine-banner-inner h2 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 40px;\r\n  line-height: 52px;\r\n  text-align: left;\r\n  padding-right: 40px;\r\n}\r\n\r\n.yellow-title {\r\n  color: #55b56d;\r\n}\r\n\r\n.active-main-right h4 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 40px;\r\n  line-height: 50px;\r\n  color: #fff;\r\n  text-align: left;\r\n}\r\n\r\n.active-main-right p {\r\n  color: #fff;\r\n  text-align: left;\r\n}\r\n\r\n.active-main-left {\r\n  width: 35%;\r\n}\r\n\r\n.active-main-right {\r\n  width: 65%;\r\n  padding-left: 70px;\r\n}\r\n\r\n.active-main-left img {\r\n  width: 100% !important;\r\n  height: 100% !important;\r\n}\r\n.out-right img {\r\n  position: relative;\r\n  top: -60px;\r\n}\r\n\r\n.out-right img {\r\n  position: relative;\r\n  top: -60px;\r\n}\r\n\r\n.out-left {\r\n  padding-right: 110px;\r\n  padding-top: 40px;\r\n}\r\n\r\n.target-box ul {\r\n  padding: 0px;\r\n  margin: 0px;\r\n}\r\n\r\n.target-box ul li img {\r\n  width: 55px !important;\r\n  height: 55px !important;\r\n  float: left;\r\n  margin-right: 10px;\r\n}\r\n\r\n.target-box ul li {\r\n  width: 100%;\r\n}\r\n\r\n.target-box ul li h6 {\r\n  text-align: left;\r\n  color: #fff;\r\n  padding-top: 7px;\r\n  line-height: 22px;\r\n  font-weight: 400;\r\n}\r\n\r\n.target-box ul li h6 span {\r\n  color: #55b56d;\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n}\r\n\r\n.comanies-main-left ul {\r\n  padding: 0px;\r\n  margin: 0px;\r\n}\r\n\r\n.comanies-main-left ul li {\r\n  float: left;\r\n  /* width: 26%; */\r\n  margin-right: 12px;\r\n  margin-top: 6px;\r\n}\r\n\r\n.comanies-main-left {\r\n  width: 65%;\r\n}\r\n\r\n/* .comanies-main-right {\r\n  width: 35%;\r\n} */\r\n\r\n.comanies-main-right .btn-lead {\r\n  margin-top: 35px;\r\n  display: inline-block;\r\n  border-color: #fff;\r\n  color: #fff;\r\n  margin-right: 10px;\r\n}\r\n\r\n.main-counter {\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.counter {\r\n  width: 50%;\r\n  margin: 0 auto;\r\n}\r\n\r\n.counter .counter-value {\r\n  color: #55b56d;\r\n  font-size: 25px;\r\n  font-weight: 500;\r\n  width: 66px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.counter h5 {\r\n  font-size: 15px;\r\n  color: #252525;\r\n}\r\n\r\n.counter small {\r\n  font-size: 25px;\r\n  color: #55b56d;\r\n}\r\n\r\n.maine-banner-inner h5 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 1.2rem;\r\n  line-height: 30px;\r\n  color: #a9a9a9;\r\n  text-align: left;\r\n  padding-right: 35px;\r\n  margin-top: 15px;\r\n}\r\n\r\n.main-vision .ultimate-inner p {\r\n  height: 120px;\r\n}\r\n\r\n.join-p {\r\n  background-color: #55b56d;\r\n  padding: 20px 20px;\r\n  border-radius: 5px;\r\n  color: #fff;\r\n  font-size: 18px;\r\n  line-height: 28px;\r\n  text-align: justify;\r\n}\r\n\r\n.maine-banner-left img {\r\n  width: 100%;\r\n  position: relative;\r\n}\r\n\r\n.input-talk input {\r\n  box-shadow: 0px 8px 41px -9px rgba(0, 0, 0, 0.09);\r\n  background-color: #fdfdfd;\r\n  border: 1px solid #ffff;\r\n  height: 50px;\r\n  margin-right: 20px;\r\n  border-radius: 0px;\r\n}\r\n\r\n.input-talk input::placeholder {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 15px;\r\n  line-height: 15px;\r\n  color: #787272;\r\n}\r\n\r\n.input-talk #basic-addon2 {\r\n  border-radius: 0px;\r\n  border: 1px solid #55b56d;\r\n  background-color: #55b56d;\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 18px;\r\n  line-height: 18px;\r\n  color: #ffffff;\r\n  padding: 0px 28px;\r\n  cursor: pointer;\r\n}\r\n\r\n.input-talk {\r\n  padding-right: 110px;\r\n  padding-top: 20px;\r\n}\r\n\r\n.input-talk input:focus {\r\n  border-color: #55b56d;\r\n}\r\n\r\n.footer-top-1 .input-group input::placeholder {\r\n  color: #fff;\r\n}\r\n\r\n:hover.btn-sign {\r\n  background-color: unset;\r\n  color: #55b56d;\r\n  border-color: #55b56d;\r\n}\r\n\r\n.input-talk:hover #basic-addon2 {\r\n  background-color: unset;\r\n  color: #55b56d;\r\n  border-color: #55b56d;\r\n}\r\n\r\n.our-leads-inner {\r\n  position: relative;\r\n}\r\n.our-leads-inner img {\r\n  height: 700px;\r\n}\r\n\r\n.our-leads-caption {\r\n  position: absolute;\r\n  left: 70px;\r\n  top: 55px;\r\n  width: 90%;\r\n}\r\n.active-main {\r\n  padding-top: 35px;\r\n}\r\n\r\n.our-leads-caption h3 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-size: 40px;\r\n  line-height: 50px;\r\n  color: #ffffff;\r\n  margin-bottom: 22px;\r\n}\r\n\r\n.our-leads-caption h5 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 20px;\r\n  line-height: 30px;\r\n  color: #ffffff;\r\n  text-align: left;\r\n}\r\n\r\n.comanies-main {\r\n  padding-top: 10px;\r\n}\r\n\r\n.show-selet select {\r\n  background-color: unset;\r\n  border: 1px solid #333;\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 16px;\r\n  line-height: 24px;\r\n  filter: invert(1);\r\n  border-radius: 8px;\r\n  width: 120px;\r\n}\r\n\r\n.show-selet select option {\r\n  color: #fff;\r\n  background-color: #000c2f;\r\n}\r\n\r\n.total-tb {\r\n  width: 100%;\r\n}\r\n\r\n.total-box {\r\n  background: rgba(26, 26, 26, 0.65);\r\n  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.17);\r\n  backdrop-filter: blur(30px);\r\n  border-radius: 12px;\r\n  width: 100%;\r\n  margin-top: 10px;\r\n  padding: 30px 20px;\r\n  padding-bottom: 40px;\r\n}\r\n\r\n.total-rate h6 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 20px;\r\n  line-height: 30px;\r\n  color: #ffffff;\r\n  width: 100%;\r\n  text-align: left;\r\n}\r\n\r\n.share-no h2 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  font-size: 45px;\r\n  line-height: 74px;\r\n  color: #ffffff;\r\n  width: 36%;\r\n}\r\n\r\n.share-no h6 {\r\n  font-style: inherit;\r\n  font-weight: 600;\r\n  font-size: 24px;\r\n  line-height: 33px;\r\n  font-family: \"Poppins\";\r\n  color: #14e644;\r\n  width: 25%;\r\n  padding-top: 26px;\r\n}\r\n\r\n.compared-box p {\r\n  color: #a1a1a1;\r\n  text-align: left;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.progress-title {\r\n  font-size: 16px !important;\r\n  font-weight: 400 !important;\r\n  color: #000;\r\n  margin: 0 0 10px 0 !important;\r\n  line-height: 9px !important;\r\n  width: 145px;\r\n  text-align: left;\r\n}\r\n.progress {\r\n  height: 8px;\r\n  line-height: 12px;\r\n  border-radius: 20px;\r\n  background: #f0f0f0;\r\n  margin-bottom: 30px;\r\n  box-shadow: none;\r\n  overflow: visible;\r\n  width: 65%;\r\n  margin-right: 15px;\r\n}\r\n.progress .progress-bar {\r\n  position: relative;\r\n  border-radius: 20px 0 0 20px;\r\n  animation: animate-positive 2s;\r\n}\r\n.progress .progress-value {\r\n  display: none;\r\n  font-size: 13px;\r\n  color: #fff;\r\n  position: absolute;\r\n  top: 0;\r\n  right: 8px;\r\n}\r\n.progess-box-inner img {\r\n  width: 25px !important;\r\n  margin-top: -5px;\r\n  margin-right: 12px;\r\n}\r\n\r\n.progess-box-inner {\r\n  margin-top: 10px;\r\n}\r\n\r\n@-webkit-keyframes animate-positive {\r\n  0% {\r\n    width: 0%;\r\n  }\r\n}\r\n@keyframes animate-positive {\r\n  0% {\r\n    width: 0%;\r\n  }\r\n}\r\n\r\n.clients-box img {\r\n  width: 165px;\r\n  margin: 0 auto;\r\n  display: block;\r\n}\r\n\r\n.clients {\r\n  padding: 45px 0px;\r\n  border-top: 1px solid #f2f2f2;\r\n  margin: 60px 0px;\r\n  border-bottom: 1px solid #f2f2f2;\r\n}\r\n\r\n.inbound h3 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-size: 40px;\r\n  line-height: 50px;\r\n  text-align: center;\r\n  padding: 0px 285px;\r\n  margin-bottom: 45px;\r\n}\r\n\r\n.inbound .nav-pills .nav-link.active,\r\n.inbound .nav-pills .show > .nav-link {\r\n  color: #fff;\r\n  background-color: #1f4572;\r\n  border-radius: 6px;\r\n  position: relative;\r\n}\r\n.inbound .nav-pills .nav-link.active:after,\r\n.inbound .nav-pills .show > .nav-link:after {\r\n  border-bottom: 15px solid transparent;\r\n  border-left: 15px solid #1f4572;\r\n  border-top: 15px solid transparent;\r\n  bottom: -20px;\r\n  content: \"\";\r\n  height: 0;\r\n  position: absolute;\r\n  width: 0;\r\n  transform: rotate(90deg);\r\n  left: 50px;\r\n}\r\n.inbound .nav-pills .nav-link img {\r\n  width: 70px;\r\n  margin: 0 auto 12px;\r\n}\r\n\r\n.inbound .nav-pills .nav-link.active img,\r\n.inbound .nav-pills .show > .nav-link img {\r\n  filter: invert(1);\r\n}\r\n\r\n.inbound .nav-pills .nav-link {\r\n  width: 205px;\r\n  margin-right: 20px;\r\n  height: 205px;\r\n  padding: 40px 38px;\r\n  text-align: center;\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 20px;\r\n  line-height: 24px;\r\n  color: #202020;\r\n}\r\n\r\n.inbound .row {\r\n  padding: 0px 125px;\r\n}\r\n\r\n.inbound .tab-content h4 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 24px;\r\n  line-height: 30px;\r\n  color: #131416;\r\n  margin-bottom: 15px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.btn-fnd {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-size: 18px;\r\n  line-height: 18px;\r\n  color: #1f4572;\r\n}\r\n.inbound .tab-content p {\r\n  padding-right: 175px;\r\n}\r\n\r\n.out {\r\n  padding: 60px 0px;\r\n  padding-bottom: 0px;\r\n  background: #000;\r\n}\r\n\r\n.out-white {\r\n  padding: 60px 0px;\r\n  padding-bottom: 0px;\r\n}\r\n\r\n.have-left img {\r\n  width: 100%;\r\n  position: relative;\r\n  top: 55px;\r\n}\r\n\r\n.start-left ul {\r\n  padding: 0px;\r\n  margin: 0px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.start-left ul li {\r\n  width: 50%;\r\n  line-height: 36px;\r\n}\r\n\r\n.start-left ul li img {\r\n  width: 7%;\r\n  margin-right: 12px;\r\n}\r\n\r\n.million-box img {\r\n  width: 12%;\r\n  margin-right: 15px;\r\n  height: 60px;\r\n}\r\n\r\n.million-box {\r\n  padding-bottom: 5px;\r\n}\r\n\r\n.million-box-right h5 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 16px;\r\n  line-height: 28px;\r\n  padding-right: 150px;\r\n}\r\n\r\n.million-box-right h5 span {\r\n  font-weight: 700;\r\n}\r\n\r\n.out h3 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 40px;\r\n  line-height: 50px;\r\n  color: #202020;\r\n  padding-right: 80px;\r\n}\r\n\r\n.out-left p {\r\n  color: #565656;\r\n  margin-bottom: 22px;\r\n}\r\n\r\n.out-left ul {\r\n  padding: 0px;\r\n  margin: 0px;\r\n}\r\n\r\n.out-left ul li {\r\n  float: left;\r\n  width: 50%;\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n  line-height: 38px;\r\n}\r\n\r\n.out-left ul li i {\r\n  margin-right: 10px;\r\n}\r\n\r\n.btn-lead {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 18px;\r\n  line-height: 18px;\r\n  color: #55b56d;\r\n  border: 1px solid #55b56d;\r\n  transition: 0.5s;\r\n  padding: 12px 25px;\r\n  margin-top: 20px;\r\n  display: inline-block;\r\n  border-radius: 5px;\r\n}\r\n\r\n:hover.btn-lead {\r\n  background-color: #55b56d;\r\n  color: #fff;\r\n}\r\n\r\n.btn-lead-hero {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 18px;\r\n  line-height: 20px;\r\n  color: #fff;\r\n  border: 1px solid #55b56d;\r\n  transition: 0.5s;\r\n  padding: 15px 30px;\r\n  display: inline-block;\r\n  border-radius: 5px;\r\n  background: #55b56d;\r\n}\r\n\r\n:hover.bgn-now {\r\n  background-color: #55b56d;\r\n  color: #fff;\r\n}\r\n\r\n.mali-box {\r\n  background: #ffffff;\r\n  box-shadow: 0px 25px 70px 10px rgba(0, 0, 0, 0.08);\r\n  padding: 35px 25px;\r\n  margin-top: 20px;\r\n  position: relative;\r\n  left: 100px;\r\n  top: 20px;\r\n}\r\n\r\n.mali-box i {\r\n  width: 50px;\r\n  height: 50px;\r\n  text-align: center;\r\n  background-color: #e9f2ff;\r\n  border-radius: 50%;\r\n  padding: 16px 16px;\r\n  color: #1f4572;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.mali-box h5 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 18px;\r\n  line-height: 23px;\r\n  color: #1f4572;\r\n}\r\n\r\n.mali-box p {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n  line-height: 22px;\r\n  color: #242426;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.mali {\r\n  width: 50%;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.sami-box {\r\n  background: #1f4572;\r\n  box-shadow: 0px 19px 33px -17px rgba(0, 0, 0, 0.25);\r\n  width: 215px;\r\n  padding: 12px 15px;\r\n}\r\n\r\n.sami-box img {\r\n  width: 40px;\r\n  border-radius: 50%;\r\n  margin-right: 10px;\r\n}\r\n\r\n.sami-box h6 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 10px;\r\n  line-height: 15px;\r\n  color: #ffffff;\r\n  margin-bottom: 0px;\r\n  margin-top: 6px;\r\n}\r\n\r\n.sami-box {\r\n  background: #1f4572;\r\n  box-shadow: 0px 19px 33px -17px rgba(0, 0, 0, 0.25);\r\n  width: 215px;\r\n  padding: 12px 15px;\r\n  position: absolute;\r\n  right: 95px;\r\n  z-index: 9;\r\n  top: 20px;\r\n}\r\n\r\n.out-right {\r\n  position: relative;\r\n}\r\n\r\n.mali-box-2:after {\r\n  content: \"\";\r\n  background-image: url(../images/email-img.png);\r\n  width: 100%;\r\n  height: 80%;\r\n  position: absolute;\r\n  top: -89px;\r\n  right: -279px;\r\n  background-repeat: no-repeat;\r\n  background-size: contain;\r\n}\r\n\r\n.mali-box-2 {\r\n  position: relative;\r\n}\r\n\r\n.have-right h3 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 40px;\r\n  line-height: 50px;\r\n  color: #fff;\r\n}\r\n\r\n.have-right p {\r\n  color: #fff;\r\n  margin-bottom: 22px;\r\n}\r\n\r\n/* .have-left {\r\n  \r\n  width: 85%;\r\n  padding: 135px 30px;\r\n  position: relative;\r\n  background-image: url(../images/uplaod-img.png);\r\n  height: 100%;\r\n} */\r\n\r\n.lead-eng h5 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 17px;\r\n  line-height: 18px;\r\n  color: #2b2b2b;\r\n}\r\n\r\n.lead-eng h6 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-size: 15px;\r\n  line-height: 18px;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.lead-eng h6 span {\r\n  color: #848484;\r\n}\r\n\r\n.lead-eng {\r\n  background: #ffffff;\r\n  box-shadow: 0px 9px 40px -10px rgba(0, 0, 0, 0.1);\r\n  width: 45%;\r\n  padding: 22px 25px;\r\n  position: absolute;\r\n  right: -35px;\r\n  top: -25px;\r\n}\r\n\r\n.have {\r\n  padding-top: 80px;\r\n  padding-bottom: 80px;\r\n  background-color: #000;\r\n}\r\n\r\n.lead-eng1 h6 span {\r\n  color: #848484;\r\n}\r\n\r\n.lead-eng1 {\r\n  background: #ffffff;\r\n  box-shadow: 0px 9px 40px -10px rgba(0, 0, 0, 0.1);\r\n  width: 45%;\r\n  padding: 22px 25px;\r\n  position: absolute;\r\n  right: -70px;\r\n  bottom: 20px;\r\n}\r\n\r\n.lead-eng1 h6 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-size: 15px;\r\n  line-height: 18px;\r\n  margin-bottom: 0px;\r\n  padding-top: 7px;\r\n}\r\n\r\n/* .have-left:before {\r\n  content: '';\r\n  background: #1F4572;\r\n  box-shadow: 0px 19.0574px 35.5738px rgba(86, 73, 206, 0.19);\r\n  width: 155px;\r\n  height: 155px;\r\n  position: absolute;\r\n  border-radius: 50%;\r\n  top: -40px;\r\n  left: -15px;\r\n}\r\n\r\n.have-left:after {\r\n  content: '';\r\n  background-image: url(../images/vouch-icon.png);\r\n  width: 22%;\r\n  height: 40%;\r\n  position: absolute;\r\n  bottom: -20px;\r\n  left: 25px;\r\n  background-repeat: no-repeat;\r\n} */\r\n\r\n/* .have-right {\r\n  padding-top: 50px;\r\n} */\r\n\r\n.btn-add i {\r\n  color: #3cb265;\r\n  font-size: 15px;\r\n  text-align: center;\r\n}\r\n\r\n.btn-add {\r\n  background-color: rgb(60 178 101 / 60%);\r\n  width: 30px;\r\n  height: 30px;\r\n  padding: 3px 9px;\r\n  border-radius: 50%;\r\n  margin-right: 20px;\r\n}\r\n\r\n.start {\r\n  padding-top: 60px;\r\n  padding-bottom: 60px;\r\n}\r\n\r\n.start-left h3 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 40px;\r\n  line-height: 50px;\r\n  color: #202020;\r\n}\r\n\r\n.start-left p {\r\n  color: #565656;\r\n  margin-bottom: 22px;\r\n}\r\n\r\n.start-left {\r\n  padding-top: 80px;\r\n}\r\n\r\n.lead-box {\r\n  /* background-color: #F9F9F9; */\r\n  padding: 35px 25px;\r\n  padding-top: 0px;\r\n  text-align: center;\r\n  /* margin-top: 20px; */\r\n  transition: all 0.3s ease-in-out;\r\n  -webkit-transition: all 0.3s ease-in-out;\r\n  -moz-transition: all 0.3s ease-in-out;\r\n  -ms-transition: all 0.3s ease-in-out;\r\n  -o-transition: all 0.3s ease-in-out;\r\n}\r\n.lead-box img {\r\n  width: 80%;\r\n}\r\n\r\n.lead-box h6 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-size: 18px;\r\n  line-height: 18px;\r\n  color: #ffffff;\r\n  background-color: #1f4572;\r\n  width: 50px;\r\n  height: 50px;\r\n  text-align: center;\r\n  padding: 17px 14px;\r\n  margin: 0 auto 20px;\r\n  border-radius: 50%;\r\n}\r\n\r\n.lead-box h5 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-size: 18px;\r\n  line-height: 18px;\r\n  color: #202020;\r\n  margin-bottom: 4px;\r\n  margin-top: 25px;\r\n}\r\n\r\n.lead-box p {\r\n  color: #565656;\r\n}\r\n\r\n.lead-market h3 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 40px;\r\n  line-height: 50px;\r\n  color: #202020;\r\n  text-align: center;\r\n  padding: 0px 305px;\r\n  margin-bottom: 55px;\r\n}\r\n.lead-market p {\r\n  text-align: center;\r\n  color: #565656;\r\n}\r\n\r\n.lead-market {\r\n  padding-top: 60px;\r\n  background-color: #f1f1f1;\r\n  padding-bottom: 60px;\r\n}\r\n\r\n.bgn-now {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 18px;\r\n  line-height: 18px;\r\n  color: #55b56d;\r\n  border: 1px solid #55b56d;\r\n  transition: 0.5s;\r\n  padding: 12px 25px;\r\n  display: inline-block;\r\n  width: 236px;\r\n  margin: 20px auto 0px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.need h3 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 40px;\r\n  line-height: 50px;\r\n  text-align: left;\r\n  color: #fff;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.need-inner-right ul {\r\n  padding: 0px;\r\n  margin: 0px;\r\n  display: inline-block;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.need-inner-right ul li {\r\n  float: left;\r\n  width: 100%;\r\n  margin-top: 15px;\r\n}\r\n\r\n.need-inner-right ul li img {\r\n  width: 6%;\r\n  float: left;\r\n  margin-right: 12px;\r\n}\r\n\r\n.need-inner-right ul li h5 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 16px;\r\n  line-height: 24px;\r\n  color: #fff;\r\n}\r\n\r\n.need-inner-right .btn-lead {\r\n  width: 139px;\r\n  margin: 0 auto;\r\n  display: flex;\r\n  border-color: #55b56d;\r\n  color: #fff;\r\n  background-color: #55b56d;\r\n}\r\n.need-inner-right {\r\n  padding-left: 25px;\r\n}\r\n.have-right .btn-lead {\r\n  border-color: #fff;\r\n  color: #fff;\r\n}\r\n\r\n.need {\r\n  padding-top: 60px;\r\n  background-color: #000000;\r\n}\r\n\r\n.with {\r\n  padding: 50px 0px;\r\n  background-repeat: no-repeat;\r\n  height: 100%;\r\n  background-size: cover;\r\n}\r\n\r\n.with-left h5 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 26px;\r\n  line-height: 35px;\r\n  padding-right: 35px;\r\n  color: #ffffff;\r\n  margin-bottom: 0px;\r\n}\r\n.with-left h3 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 40px;\r\n  line-height: 50px;\r\n  color: #202020;\r\n  text-align: center;\r\n  padding: 0px 305px;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.with-left h4 {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.with-left p {\r\n  padding: 0px 89px;\r\n}\r\n\r\n.looking-main-left {\r\n  width: 26%;\r\n}\r\n\r\n.looking-main-right {\r\n  width: 26%;\r\n}\r\n\r\n.looking-main {\r\n  justify-content: center;\r\n  margin: 15px 0px;\r\n}\r\n.looking-main h5 {\r\n  color: #55b56d;\r\n}\r\n\r\n.with-left {\r\n  text-align: center;\r\n}\r\n\r\n.looking-main-right select {\r\n  border: 2px solid #2f92f2;\r\n  border-radius: 0px;\r\n  width: 85%;\r\n  height: 45px;\r\n  font-weight: 600;\r\n  font-size: 18px;\r\n  line-height: 26px;\r\n  color: #2f92f2;\r\n}\r\n\r\n.learn-20 h2 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 50px;\r\n  line-height: 50px;\r\n  margin-bottom: 2px;\r\n  color: #ffffff;\r\n}\r\n\r\n.learn-20 p {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n  line-height: 14px;\r\n  color: #dadada;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.btn-lrnbl {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 22px;\r\n  line-height: 22px;\r\n  color: #1f4572;\r\n  background-color: #ffffff;\r\n  padding: 12px 95px;\r\n  display: inline-block;\r\n  margin-top: 50px;\r\n  border: 1px solid #fff;\r\n}\r\n\r\n:hover.btn-lrnbl {\r\n  background-color: unset;\r\n  color: #fff;\r\n}\r\n\r\n.with .row {\r\n  padding: 0px 110px;\r\n}\r\n\r\n.learn-20 {\r\n  width: 200px;\r\n}\r\n\r\n.with-right {\r\n  padding-left: 15px;\r\n}\r\n\r\n.learn-box {\r\n  position: relative;\r\n}\r\n\r\n.learn-box:after {\r\n  content: \"\";\r\n  border-top: 2px solid #ffff;\r\n  position: absolute;\r\n  left: 0px;\r\n  top: -30px;\r\n  width: 86.7%;\r\n}\r\n\r\n.testimonials h3 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 40px;\r\n  line-height: 50px;\r\n  text-align: center;\r\n  color: #202020;\r\n}\r\n\r\n.testimonials p {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 16px;\r\n  line-height: 24px;\r\n  color: #565656;\r\n  padding: 1px 283px;\r\n  text-align: center;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.testimonials .swiper {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.testimonials .swiper-button-next:after,\r\n.testimonials .swiper-button-prev:after {\r\n  font-size: 16px;\r\n  background-color: #55b56d;\r\n  padding: 9px 12px;\r\n  border-radius: 0px;\r\n  color: #fff;\r\n  text-align: center;\r\n}\r\n\r\n.testimonials .swiper-slide {\r\n  text-align: center;\r\n  font-size: 18px;\r\n  background: #fff;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.testimonials .swiper-slide img {\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.testimonials .swiper {\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n/* .testimonials-box {\r\n  background-color: #f9f9f9;\r\n  padding: 55px 60px;\r\n} */\r\n.testimonials-box {\r\n  min-height: 250px;\r\n  background-color: #f9f9f9;\r\n  padding: 25px 25px;\r\n  margin: 0px 10px;\r\n}\r\n\r\n.testimonials {\r\n  padding-top: 75px;\r\n  padding-bottom: 75px;\r\n}\r\n\r\n.testimonials-box-left h4 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 38px;\r\n  line-height: 42px;\r\n  text-align: left;\r\n  margin-bottom: 0px;\r\n  padding-right: 90px;\r\n  color: #55b56d;\r\n}\r\n\r\n.testimonials-box-right p {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 16px;\r\n  line-height: 30px;\r\n  text-align: left;\r\n  padding: 0px;\r\n}\r\n\r\n.testimonials .swiper-horizontal {\r\n  padding: 0px 60px;\r\n}\r\n\r\n.king-box img {\r\n  width: 50px !important;\r\n  float: left;\r\n  margin-right: 20px;\r\n}\r\n\r\n.king-box h5 {\r\n  text-align: left;\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  font-size: 16px;\r\n  line-height: 24px;\r\n  margin-bottom: 2px;\r\n  color: #55b56d;\r\n}\r\n\r\n.king-box h6 {\r\n  text-align: left;\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 13px;\r\n  line-height: 24px;\r\n  color: #3c3c3c;\r\n}\r\n\r\n/**blog**/\r\n.blog-banner {\r\n  background-image: url(../images/blg-banner.png);\r\n  width: 100%;\r\n  height: 410px;\r\n  background-size: cover;\r\n  background-repeat: no-repeat;\r\n  position: relative;\r\n}\r\n\r\n.latest-title h3 {\r\n  color: #3b3d4c;\r\n  margin-bottom: 30px;\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 28.5504px;\r\n  line-height: 43px;\r\n}\r\n\r\n.latest-article img {\r\n  width: 100%;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.latest-article h3 {\r\n  color: #3b3d4c;\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  font-size: 25.4914px;\r\n  line-height: 32px;\r\n}\r\n\r\n.latest-article p {\r\n  color: #3b3d4c;\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 16.3145px;\r\n  line-height: 22px;\r\n  margin-bottom: 25px;\r\n  padding-right: 10px;\r\n}\r\n\r\n.reads-latest a {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 18px;\r\n  line-height: 30px;\r\n  color: #55b56d;\r\n  border: 1px solid #55b56d;\r\n  padding: 6px 26px;\r\n  display: inline-block;\r\n  margin-bottom: 45px;\r\n}\r\n\r\n.universities.latest {\r\n  padding: 55px 0px;\r\n}\r\n\r\n.input-group.serach-btn {\r\n  background: #55b56d;\r\n  width: 260px;\r\n  height: 44px;\r\n}\r\n\r\n.input-group.serach-btn input.form-control {\r\n  background-color: unset;\r\n  border-color: #55b56d;\r\n}\r\n\r\n.input-group.serach-btn span#basic-addon2 {\r\n  background-color: unset;\r\n  border-color: #55b56d;\r\n}\r\n\r\n.input-group.serach-btn span#basic-addon2 i {\r\n  color: #fff;\r\n  font-weight: 300;\r\n}\r\n\r\n.categories h3 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-size: 22.573px;\r\n  line-height: 34px;\r\n  color: #202020;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.categories h3:after {\r\n  content: \"\";\r\n  width: 45px;\r\n  position: absolute;\r\n  top: 35px;\r\n  left: 0px;\r\n  height: 3px;\r\n  background-color: #55b56d;\r\n}\r\n\r\n.categories ul {\r\n  padding: 0px;\r\n  margin: 0px;\r\n  margin-bottom: 35px;\r\n}\r\n\r\n.categories ul li {\r\n  list-style: none;\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 275;\r\n  font-size: 15.3496px;\r\n  line-height: 45px;\r\n  color: #202020;\r\n  border-bottom: 1px solid #55b56d;\r\n}\r\n\r\n.categories ul li span {\r\n  float: right;\r\n}\r\n\r\n.recent-blog h3 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-size: 22.573px;\r\n  line-height: 34px;\r\n  color: #202020;\r\n  margin-bottom: 35px;\r\n}\r\n\r\n.recent-blog h3:after {\r\n  content: \"\";\r\n  width: 45px;\r\n  position: absolute;\r\n  top: 35px;\r\n  left: 0px;\r\n  height: 3px;\r\n  background-color: #55b56d;\r\n}\r\n.recent-blog-left img {\r\n  width: 100%;\r\n}\r\n.recent-blog-left {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.recent-blog-right h5 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 275;\r\n  font-size: 14px;\r\n  line-height: 21px;\r\n  color: #3b3d4c;\r\n}\r\n\r\n.recent-blog-right h4 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n  line-height: 24px;\r\n  color: #202020;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.tags h3 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-size: 22.573px;\r\n  line-height: 34px;\r\n  color: #202020;\r\n  margin-bottom: 35px;\r\n}\r\n\r\n.tags h3:after {\r\n  content: \"\";\r\n  width: 45px;\r\n  position: absolute;\r\n  top: 35px;\r\n  left: 0px;\r\n  height: 3px;\r\n  background-color: #55b56d;\r\n}\r\n\r\n.tags ul {\r\n  padding: 0px;\r\n  margin: 0px;\r\n}\r\n\r\n.tags ul li {\r\n  list-style: none;\r\n  float: left;\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 300;\r\n  font-size: 13px;\r\n  line-height: 20px;\r\n  margin-right: 8px;\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.tags ul li a {\r\n  color: #fff;\r\n  background: #55b56d;\r\n  padding: 6px 12px;\r\n  text-decoration: none;\r\n}\r\n\r\n.input-group.serach-btn input.form-control::placeholder {\r\n  color: #fff;\r\n}\r\n\r\n.reads-latest:hover a {\r\n  background-color: #55b56d;\r\n  color: #fff;\r\n}\r\n\r\n.reads-latest {\r\n  width: 156px;\r\n}\r\n\r\n.blog-banners {\r\n  width: 46%;\r\n  padding-left: 105px;\r\n  padding-top: 68px;\r\n  position: relative;\r\n  z-index: 10;\r\n}\r\n\r\n.blog-banners h2 {\r\n  color: #ffffff;\r\n  position: relative;\r\n  z-index: 1;\r\n  margin-bottom: 25px;\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-size: 52.6882px;\r\n  line-height: 66px;\r\n}\r\n\r\n.btn-blg {\r\n  background-color: #55b56d;\r\n  border: 1px solid #55b56d;\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-size: 18px;\r\n  line-height: 30px;\r\n  color: #fff;\r\n  padding: 5px 25px;\r\n  display: inline-block;\r\n}\r\n\r\n/**footer**/\r\n.footer-top {\r\n  padding: 75px 0px;\r\n  padding-bottom: 20px;\r\n  background-color: #000;\r\n}\r\n\r\n.footer-top-1 p {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n  line-height: 24px;\r\n  color: #fff;\r\n  padding-right: 65px;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.footer-top-1 a img {\r\n  width: 220px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.footer-top-1 h5 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-size: 12px;\r\n  line-height: 14px;\r\n  color: #000000;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.socila-icon li a {\r\n  color: #000000 !important;\r\n  font-size: 15px;\r\n  display: block;\r\n}\r\n\r\n.socila-icon {\r\n  padding: 0px;\r\n  margin: 0px;\r\n}\r\n\r\n.footer-top-2 h4 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  font-size: 20px;\r\n  line-height: 24px;\r\n  color: #55b56d;\r\n  margin-top: 25px;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.footer-top-2 ul {\r\n  padding: 0px;\r\n  margin: 0px;\r\n}\r\n\r\n.socila-icon li {\r\n  border: 1px solid #fff;\r\n  width: 35px;\r\n  height: 35px;\r\n  padding: 3px 10px;\r\n  margin-right: 10px;\r\n  border-radius: 14%;\r\n  text-align: center;\r\n  transition: 0.5s;\r\n  background-color: #fff;\r\n}\r\n\r\n.socila-icon li:hover {\r\n  background-color: #55b56d;\r\n}\r\n\r\n.footer-top-1 .input-group:hover #basic-addon2 {\r\n  background-color: #1f4572;\r\n  border-color: #1f4572;\r\n}\r\n\r\n.socila-icon li:hover a {\r\n  color: #fff;\r\n}\r\n\r\n.footer-top-2 ul li a {\r\n  color: #fff;\r\n  transition: 0.5s;\r\n}\r\n\r\n.footer-top-1 .input-group {\r\n  height: 45px;\r\n  margin-top: 20px;\r\n  width: 82%;\r\n}\r\n\r\n.footer-top-1 .input-group input {\r\n  background-color: unset;\r\n  border-color: #f9f9f9;\r\n  border-radius: 0px;\r\n  padding: 0px 18px;\r\n  padding-bottom: 0px;\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  font-size: 15px;\r\n  line-height: 28px;\r\n  color: #fff;\r\n}\r\n\r\n.footer-top-1 .input-group #basic-addon2 {\r\n  background-color: #55b56d;\r\n  border-color: #fff;\r\n  color: #ffffff;\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 12px;\r\n  line-height: 131%;\r\n  border-radius: 0px;\r\n  padding: 0px 18px;\r\n  margin-left: 0px;\r\n  cursor: pointer;\r\n  transition: 0.5s;\r\n}\r\n\r\n.footer-top-2 p {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 16px;\r\n  line-height: 24px;\r\n  color: #fff;\r\n  padding-right: 18px;\r\n  margin-top: 25px;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.subrcb {\r\n  padding-left: 50px;\r\n}\r\n\r\n.socila-icon li:nth-child(3) {\r\n  padding: 2px 10px;\r\n  padding-left: 11px;\r\n}\r\n\r\n.copy-content p {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 12px;\r\n  line-height: 14px;\r\n  color: #fff;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.copy-box {\r\n  width: 100%;\r\n  padding-top: 50px;\r\n}\r\n\r\n.copy-content {\r\n  width: 50%;\r\n}\r\n\r\n.footer-top-2 ul li {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 16px;\r\n  line-height: 32px;\r\n}\r\n\r\n.footer-top-2 ul li:hover a {\r\n  color: #55b56d;\r\n}\r\n\r\n.scroll-to-top {\r\n  background-color: #55b56d;\r\n  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;\r\n  border: none;\r\n  border-radius: 50%;\r\n  bottom: 53px;\r\n  color: #fff;\r\n  cursor: pointer;\r\n  display: none;\r\n  font-size: 22px;\r\n  height: 50px;\r\n  line-height: 50px;\r\n  position: fixed;\r\n  right: 20px;\r\n  text-align: center;\r\n  width: 50px;\r\n  z-index: 100;\r\n  transition: all 0.3s ease-in-out;\r\n  -webkit-transition: all 0.3s ease-in-out;\r\n  -moz-transition: all 0.3s ease-in-out;\r\n  -ms-transition: all 0.3s ease-in-out;\r\n  -o-transition: all 0.3s ease-in-out;\r\n}\r\n\r\n.fixed-top {\r\n  top: -40px;\r\n  transform: translateY(40px);\r\n  transition: transform 0.3s;\r\n  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;\r\n}\r\n\r\n.quick-form {\r\n  flex-wrap: wrap;\r\n  justify-content: space-around;\r\n}\r\n\r\n.form-grp {\r\n  width: 48%;\r\n}\r\n\r\n.quick {\r\n  padding: 55px 0px;\r\n  background-color: #f9f9f9;\r\n  background-color: #fff;\r\n  border-radius: 10px;\r\n  padding: 30px 20px;\r\n}\r\n\r\n.form-grp input {\r\n  box-shadow: 0px 8px 41px -9px rgba(0, 0, 0, 0.09);\r\n  background-color: #fdfdfd;\r\n  border: 1px solid #ffff;\r\n  height: 50px;\r\n  border-radius: 0px;\r\n}\r\n\r\n.form-grp label {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 20px;\r\n  line-height: 28px;\r\n}\r\n.form-grp .form-control[type=\"file\"] {\r\n  overflow: hidden;\r\n  padding: 12px 10px;\r\n  background-color: #e9ecef;\r\n}\r\n.form-grp input::placeholder {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 15px;\r\n  line-height: 15px;\r\n  color: #787272;\r\n}\r\n\r\n.form-grp input:focus {\r\n  border-color: #55b56d;\r\n}\r\n.form-grp select:focus {\r\n  box-shadow: none;\r\n  border-color: #55b56d;\r\n}\r\n.form-grp select {\r\n  box-shadow: 0px 8px 41px -9px rgba(0, 0, 0, 0.09);\r\n  background-color: #fdfdfd;\r\n  border: 1px solid #ffff;\r\n  height: 50px;\r\n  border-radius: 0px;\r\n}\r\n\r\n.btn-quick {\r\n  background-color: #55b56d;\r\n  border: 1px solid #55b56d;\r\n  transition: 0.5s;\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 18px;\r\n  color: #f9f9f9;\r\n  border-radius: 5px;\r\n  padding: 6px 35px;\r\n  display: block;\r\n  padding-top: 8px;\r\n  margin: 25px auto 0px;\r\n  transition: 0.5s;\r\n}\r\n\r\n:hover.btn-quick {\r\n  background-color: unset;\r\n  color: #55b56d;\r\n}\r\n\r\n/**domainform**/\r\n.annad-cnnt-lst {\r\n  display: inline-block;\r\n  padding-top: 12px;\r\n}\r\n\r\n.annad-cnnt-lst ul li {\r\n  list-style: none;\r\n  float: left;\r\n  margin-right: 8px;\r\n  margin-bottom: 12px;\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 131%;\r\n}\r\n\r\n.annad-cnnt-lst .btn-outline-danger {\r\n  color: #55b56d;\r\n  border-color: #55b56d;\r\n  background-color: unset;\r\n  font-size: 14px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.btn-check:active + .btn-outline-danger,\r\n.btn-check:checked + .btn-outline-danger,\r\n.btn-outline-danger.active,\r\n.btn-outline-danger.dropdown-toggle.show,\r\n.btn-outline-danger:active {\r\n  color: #fff;\r\n  background-color: #55b56d;\r\n  border-color: #55b56d;\r\n}\r\n\r\n.btn-check:active + .btn-outline-danger:focus,\r\n.btn-check:checked + .btn-outline-danger:focus,\r\n.btn-outline-danger.active:focus,\r\n.btn-outline-danger.dropdown-toggle.show:focus,\r\n.btn-outline-danger:active:focus {\r\n  box-shadow: 0 0 0 0.25rem rgb(249 249 249);\r\n}\r\n.btn-check:focus + .btn-outline-danger,\r\n.btn-outline-danger:focus {\r\n  box-shadow: 0 0 0 0.25rem rgb(249 249 249);\r\n}\r\n\r\n.annad-cnnt-lst ul {\r\n  padding: 0px;\r\n  margin: 0px;\r\n}\r\n\r\n/*signup*/\r\n.logine {\r\n  border-radius: 25px;\r\n  max-width: 550px;\r\n  margin: 0 auto;\r\n  padding: 20px 20px 0;\r\n  border: 1px solid #e1dcdc;\r\n  padding-bottom: 20px;\r\n  background-color: #fff;\r\n  box-shadow: 0 0 5px 1px #e2e2e2;\r\n  position: relative;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: space-between;\r\n  justify-content: center;\r\n}\r\n\r\n.logine label {\r\n  font-size: 15px;\r\n  font-weight: 400;\r\n  color: #212529;\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n\r\n  line-height: 28px;\r\n}\r\n\r\n.logine .form-control {\r\n  height: 38px;\r\n  border-radius: 14px;\r\n}\r\n\r\n.logine label {\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  color: #212529;\r\n}\r\n\r\n.logine .form-control {\r\n  height: 38px;\r\n  border-radius: 14px;\r\n}\r\n\r\n.field-icon {\r\n  float: right;\r\n  margin-left: -25px;\r\n  margin-top: -25px;\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\n.btn.btre {\r\n  padding: 7px 124px;\r\n  background-color: #55b56d;\r\n  border-color: #55b56d;\r\n  margin-top: 25px;\r\n  border-radius: 14px;\r\n  width: 100%;\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  transition: 0.5s;\r\n}\r\n.btn:hover.btre {\r\n  background-color: unset;\r\n  color: #55b56d;\r\n}\r\n\r\n.frg-btn h6 {\r\n  text-align: center;\r\n  margin: 10px 0px;\r\n  color: #000000;\r\n  cursor: none;\r\n}\r\n\r\n.sales-left {\r\n  padding: 80px 0px;\r\n  background-color: #f9f9f9;\r\n}\r\n\r\n.logine .form-group {\r\n  width: 48%;\r\n  margin: 0 auto 8px;\r\n}\r\n\r\n.logine .form-select {\r\n  height: 38px;\r\n  border-radius: 14px;\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 15px;\r\n}\r\n\r\n.logine .form-label {\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.logine h4 {\r\n  width: 100%;\r\n  text-align: center;\r\n  margin-bottom: 20px;\r\n  font-size: 25px;\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n}\r\n\r\na.frg-btn {\r\n  clear: both;\r\n  width: 100%;\r\n}\r\n\r\n.logine ul li {\r\n  float: left;\r\n  /* margin-right: 13px; */\r\n  text-align: center;\r\n  width: 33%;\r\n}\r\n\r\n.logine ul {\r\n  padding: 0px;\r\n  margin: 0px;\r\n  display: inline;\r\n  width: 16%;\r\n}\r\n\r\n.logine ul li a i.fa.fa-facebook {\r\n  color: #3b5998;\r\n}\r\n.logine ul li a i.fa.fa-google-plus {\r\n  color: #db4a39;\r\n}\r\n.logine ul li a i.fa.fa-linkedin {\r\n  color: #0072b1;\r\n}\r\n\r\n/*blogdetail*/\r\n\r\n.universities-left h2 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 35px;\r\n  line-height: 52px;\r\n  color: #000;\r\n}\r\n\r\n.universities-left ul li {\r\n  list-style: none;\r\n  float: left;\r\n  margin-right: 20px;\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 12px;\r\n  line-height: 18px;\r\n}\r\n\r\n.universities-left ul li a {\r\n  color: #000000;\r\n  text-decoration: none;\r\n}\r\n\r\n.universities-left ul li a i {\r\n  margin-right: 5px;\r\n  color: #55b56d;\r\n}\r\n\r\n.btn-sbmt {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 12px;\r\n  line-height: 131%;\r\n  color: #ffffff;\r\n  background-color: #55b56d;\r\n  border: 1px solid #55b56d;\r\n  transition: 0.5s;\r\n  padding: 10px 28px;\r\n  border-radius: 5px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.whatp ul li {\r\n  float: inherit;\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 13px;\r\n  line-height: 20px;\r\n  color: #000000;\r\n}\r\n\r\n.universities-left ul {\r\n  margin: 0px;\r\n  padding: 0px;\r\n  margin-bottom: 8px;\r\n  display: inline-block;\r\n}\r\n.universities-left img {\r\n  width: 100%;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n/**news**/\r\n.fireside-main img {\r\n  width: 48%;\r\n  margin-right: 14px;\r\n}\r\n\r\n.fireside-main-rigth {\r\n  width: 50%;\r\n}\r\n\r\n.fireside {\r\n  background-color: #f9f9f9;\r\n  padding: 55px 0px;\r\n}\r\n\r\n.fireside h3 {\r\n  font-size: 25px;\r\n  font-family: \"Poppins\";\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.fireside-main-rigth h4 {\r\n  font-size: 18px;\r\n  line-height: 22px;\r\n  text-align: justify;\r\n  font-family: \"Poppins\";\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.fireside-main-rigth p {\r\n  text-align: justify;\r\n}\r\n\r\n/**contact**/\r\n.form-grp textarea.form-control {\r\n  box-shadow: 0px 8px 41px -9px rgba(0, 0, 0, 0.09);\r\n  background-color: #fdfdfd;\r\n  border: 1px solid #ffff;\r\n\r\n  border-radius: 0px;\r\n}\r\n\r\n.quick h3 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 40px;\r\n  line-height: 50px;\r\n  color: #202020;\r\n  text-align: center;\r\n  margin-bottom: 35px;\r\n}\r\n\r\n.austrial h3 {\r\n  font-size: 25px;\r\n  font-family: \"Poppins\";\r\n  color: #55b56d;\r\n  font-weight: 500;\r\n  margin-bottom: 18px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.austrial ul li {\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.austrial ul li a {\r\n  color: #7a7a7a;\r\n  font-size: 14px;\r\n  line-height: 22px;\r\n  font-family: \"Poppins\";\r\n  text-decoration: none;\r\n}\r\n\r\n.austrial ul li a i {\r\n  font-size: 13px;\r\n  margin-right: 15px;\r\n  border: 1px solid #333;\r\n  width: 24px;\r\n  height: 24px;\r\n  text-align: center;\r\n  line-height: 22px;\r\n  color: #55b56d;\r\n}\r\n\r\n.austrial {\r\n  border: 1px solid #eaeaea;\r\n  padding: 45px 35px;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.austrial ul {\r\n  padding: 0px;\r\n  margin: 0px;\r\n  display: inline-block;\r\n}\r\n\r\n.mapse {\r\n  padding: 55px 0px;\r\n}\r\n/*privacy*/\r\n.privacy-main h3 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 40px;\r\n  line-height: 50px;\r\n  color: #202020;\r\n  text-align: center;\r\n  margin-bottom: 35px;\r\n}\r\n\r\n.privacy-main {\r\n  padding: 55px 0px;\r\n}\r\n\r\n.privacy-inner h4 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 28px;\r\n  line-height: 32px;\r\n  color: #202020;\r\n  margin-top: 15px;\r\n}\r\n\r\n/*award*/\r\n.promoting h3 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 40px;\r\n  line-height: 50px;\r\n  color: #202020;\r\n  text-align: center;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.promoting {\r\n  padding: 50px 0px;\r\n}\r\n\r\n.promoting a img {\r\n  margin-bottom: 25px;\r\n}\r\n\r\n.promoting p {\r\n  text-align: center;\r\n  margin-bottom: 25px;\r\n  padding: 0px 220px;\r\n}\r\n\r\n.research {\r\n  background-color: #f9f9f9;\r\n  padding: 55px 0px;\r\n}\r\n\r\n.research-box ul {\r\n  padding: 0px;\r\n  margin: 0px;\r\n}\r\n\r\n.research-box ul li img {\r\n  width: 9%;\r\n  margin-right: 8px;\r\n}\r\n\r\n.research-box {\r\n  box-shadow: 0px 8px 41px -9px rgba(0, 0, 0, 0.09);\r\n  background-color: #fdfdfd;\r\n  border: 1px solid #ffff;\r\n  padding: 45px 20px;\r\n}\r\n\r\n.research-box ul li {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 16px;\r\n  line-height: 38px;\r\n}\r\n\r\n.research-box h5 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-size: 18px;\r\n  line-height: 18px;\r\n  color: #202020;\r\n  margin-bottom: 12px;\r\n  margin: 15px 0px;\r\n  text-align: center;\r\n  margin-top: 25px;\r\n}\r\n\r\n.icon-featured {\r\n  background-color: #55b56d;\r\n}\r\n\r\n.icon-featured {\r\n  display: inline-block;\r\n  font-size: 0;\r\n  margin: 15px;\r\n  width: 110px;\r\n  height: 110px;\r\n  border-radius: 50%;\r\n  text-align: center;\r\n  position: relative;\r\n  z-index: 1;\r\n  color: #fff;\r\n  font-size: 2.3em;\r\n  line-height: 110px;\r\n  margin: 0 auto;\r\n  display: block;\r\n}\r\n\r\n/*testimonials*/\r\n.client {\r\n  width: 100%;\r\n  height: 100%;\r\n  background: #f9f9f9;\r\n}\r\n\r\n.carousel-icon i {\r\n  font-size: 5rem;\r\n  color: rgba(255, 255, 255, 0.3);\r\n  color: #000;\r\n}\r\n\r\n.carousel-item i {\r\n  font-size: 1.6rem;\r\n  color: rgba(255, 255, 255, 0.3);\r\n  color: #000;\r\n}\r\n\r\n.t-card {\r\n  padding: 1.8125rem 1.125rem;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  border-radius: 1.25rem;\r\n  color: #fff;\r\n  height: auto;\r\n  box-shadow: 0px 8px 41px -9px rgba(0, 0, 0, 0.09);\r\n  background-color: #fff;\r\n}\r\n\r\n.arrow-down {\r\n  width: 0;\r\n  height: 0;\r\n  border-left: 1.5625rem solid transparent;\r\n  border-right: 1.5625rem solid transparent;\r\n  border-top: 1.25rem solid rgba(0, 0, 0, 0.5);\r\n  border-top: 1.25rem solid rgb(255 255 255);\r\n}\r\n\r\n.client h1 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 40px;\r\n  line-height: 50px;\r\n  color: #202020;\r\n  text-align: center;\r\n}\r\n\r\n.btn-outline-light {\r\n  color: #55b56d !important;\r\n  border: 1px solid #333;\r\n}\r\n\r\n.client h4 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-size: 18px;\r\n  line-height: 18px;\r\n  color: #202020;\r\n}\r\n\r\n.testimonial_subtitle {\r\n  color: #3b3d4c;\r\n}\r\n\r\n.t-card p {\r\n  color: #3b3d4c;\r\n}\r\n/**lead**/\r\n\r\n.gj-datepicker-bootstrap button[role=\"right-icon\"] .gj-icon,\r\n.gj-datepicker-bootstrap button[role=\"right-icon\"] .material-icons {\r\n  position: absolute;\r\n  font-size: 21px;\r\n  top: 15px;\r\n  left: 0.55rem;\r\n}\r\n\r\n/*exam*/\r\n.questionpaper {\r\n  padding: 50px 0px;\r\n}\r\n.questionpaper-cnt ul {\r\n  padding: 0px;\r\n  margin: 0px;\r\n  border-bottom: 1px solid #333;\r\n  padding-bottom: 18px;\r\n}\r\n.questionpaper-cnt ul li {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 16px;\r\n  line-height: 180%;\r\n  color: #000000;\r\n  list-style: none;\r\n  text-align: left;\r\n}\r\n\r\n.questionpaper-cnt h5 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 19px;\r\n  line-height: 140.5%;\r\n  color: #000000;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.questionpaper-cnt h4 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 20px;\r\n  line-height: 160.5%;\r\n  color: rgba(0, 0, 0, 0.66);\r\n  margin-bottom: 0px;\r\n  margin-top: 22px;\r\n  text-align: justify;\r\n}\r\n\r\n.questionpaper h3 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  font-size: 35px;\r\n  line-height: 140.5%;\r\n  color: #000000;\r\n  text-align: center;\r\n}\r\n.questionpaper-cnt ul h2 {\r\n  font-size: 25px;\r\n  text-align: center;\r\n  margin: 10px 0px;\r\n  font-weight: 700;\r\n}\r\n\r\n/* .questionpaper .row {\r\n  padding: 0px 40px;\r\n} */\r\n.questionpaper-cnt h3 {\r\n  font-size: 22px;\r\n  margin-bottom: 0px;\r\n  margin-top: 20px;\r\n}\r\n\r\n/**Subscriptions***/\r\n\r\n.pricing-card {\r\n  border: none;\r\n  border-radius: 4px;\r\n  margin-bottom: 28px;\r\n  -webkit-transition: all 0.6s;\r\n  transition: all 0.6s;\r\n}\r\n\r\n.pricing-card .card-header {\r\n  background-color: #55b56d;\r\n  color: #fff;\r\n  padding-top: 40px;\r\n  padding-bottom: 36px;\r\n}\r\n\r\n.pricing-plan-title {\r\n  font-size: 20px;\r\n  color: inherit;\r\n  margin-bottom: 0;\r\n  font-weight: normal;\r\n}\r\n\r\n.pricing-plan-cost {\r\n  font-size: 28px;\r\n  font-weight: bold;\r\n}\r\n.pricing-card .card-body {\r\n  padding: 22px 35px 27px;\r\n}\r\n.pricing-plan-features {\r\n  list-style: none;\r\n  padding-left: 0;\r\n  color: #303132;\r\n  font-size: 14px;\r\n  line-height: 2.86;\r\n  margin-bottom: 16px;\r\n}\r\n.pricing-plan-features li {\r\n  border-bottom: 1px solid #e3e3e3;\r\n}\r\n\r\n.pricing-plan-purchase-btn {\r\n  color: #fff;\r\n  background-color: #55b56d;\r\n  border-color: #55b56d;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  padding: 13px 20px;\r\n  border-radius: 6px;\r\n  -webkit-transition: all 0.4s;\r\n  transition: all 0.4s;\r\n  position: relative;\r\n}\r\n\r\n.subscriptions h4 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 40px;\r\n  line-height: 50px;\r\n  color: #202020;\r\n  text-align: center;\r\n  margin-bottom: 35px;\r\n}\r\n\r\n.subscriptions {\r\n  padding: 55px 0px;\r\n}\r\n\r\n/**memberdetails**/\r\n.ourmembers-inner img {\r\n  width: 18%;\r\n}\r\n.ourmembers-inner h6 {\r\n  text-align: center;\r\n  color: #565656;\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: 18px;\r\n  line-height: 24px;\r\n}\r\n\r\n.ourmembers-inner p {\r\n  text-align: center;\r\n  color: #565656;\r\n}\r\n\r\n.ourmembers-inner ul {\r\n  padding: 0px;\r\n  margin: 0px;\r\n  display: inline-block;\r\n}\r\n\r\n.ourmembers-inner ul li {\r\n  list-style: none;\r\n  float: left;\r\n  margin-right: 10px;\r\n  background-color: #55b56d;\r\n  width: 35px;\r\n  height: 35px;\r\n  border-radius: 5px;\r\n  padding: 5px 10px;\r\n  text-align: center;\r\n  border: 1px solid #55b56d;\r\n}\r\n.ourmembers-inner ul li a {\r\n  color: #fff;\r\n}\r\n\r\n.ourmembers-inner {\r\n  background-color: #fff;\r\n  box-shadow: 0px 8px 41px -9px rgba(0, 0, 0, 0.09);\r\n  padding: 40px 40px;\r\n  margin: 0px 170px;\r\n  text-align: center;\r\n}\r\n\r\n.ourmembers-inner h5 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-size: 18px;\r\n  line-height: 18px;\r\n  color: #202020;\r\n  margin-bottom: 4px;\r\n  margin-top: 25px;\r\n}\r\n\r\n/*faq*/\r\n\r\n/* Custom style */\r\n.accordion-button::after {\r\n  background-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='%23333' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' d='M8 0a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2H9v6a1 1 0 1 1-2 0V9H1a1 1 0 0 1 0-2h6V1a1 1 0 0 1 1-1z' clip-rule='evenodd'/%3e%3c/svg%3e\");\r\n  transform: scale(0.7) !important;\r\n}\r\n.accordion-button:not(.collapsed)::after {\r\n  background-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='%23333' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' d='M0 8a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1z' clip-rule='evenodd'/%3e%3c/svg%3e\");\r\n}\r\n.faqs {\r\n  padding: 55px 0px;\r\n}\r\n.faqs .accordion-item {\r\n  border: none;\r\n}\r\n\r\n.faqs .accordion-button:not(.collapsed) {\r\n  background-color: #55b56d;\r\n  color: #fff;\r\n}\r\n.faqs .accordion-button:not(.collapsed)::after {\r\n  filter: invert(1);\r\n}\r\n\r\n.faqs .card-body {\r\n  background-color: #f2efef;\r\n  padding: 1%;\r\n}\r\n\r\n.faqs h3 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 40px;\r\n  line-height: 50px;\r\n  color: #000;\r\n  text-align: center;\r\n  margin-bottom: 35px;\r\n}\r\n\r\n.faqs .accordion-button {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  font-size: 18px;\r\n  line-height: 18px;\r\n  color: #202020;\r\n  background-color: #f2efef;\r\n  margin-top: 10px;\r\n}\r\n\r\n.faqs .accordion-item:first-of-type .accordion-button {\r\n  border-top-left-radius: 0px;\r\n  border-top-right-radius: 0px;\r\n}\r\n\r\n.faqs .card-body p {\r\n  font-size: 16px;\r\n  line-height: 26px;\r\n}\r\n\r\n.faqs .accordion-button:focus {\r\n  box-shadow: none;\r\n}\r\n\r\n/*joblists*/\r\n.joblist {\r\n  background-color: #000;\r\n  padding: 50px 0px;\r\n}\r\n\r\n.joblist-inner ul {\r\n  padding: 0px;\r\n  margin: 0px;\r\n  display: inline-block;\r\n}\r\n\r\n.joblist-inner ul li {\r\n  list-style: none;\r\n  float: left;\r\n  width: 100%;\r\n  font-family: \"Poppins\";\r\n  font-size: 15px;\r\n  line-height: 26px;\r\n  color: #fff;\r\n  text-align: center;\r\n}\r\n\r\n.joblist-inner {\r\n  box-shadow: 0px 8px 41px -9px rgba(0, 0, 0, 0.09);\r\n  background-color: #000;\r\n  padding: 30px 25px;\r\n  margin-bottom: 25px;\r\n  border: 1px solid grey;\r\n}\r\n\r\n.joblist h3 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 40px;\r\n  line-height: 50px;\r\n  color: #fff;\r\n  text-align: center;\r\n  margin-bottom: 35px;\r\n}\r\n\r\n.joblist h4 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  font-size: 22px;\r\n  line-height: 24px;\r\n  color: #55b56d;\r\n  margin-bottom: 12px;\r\n  text-align: center;\r\n}\r\n\r\n.aply-contact form .form-group {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.aply-contact form .form-group .message-field {\r\n  border: 1px solid #000;\r\n  width: 100%;\r\n  border-radius: 6px;\r\n  padding-left: 10px;\r\n  padding-top: 10px;\r\n}\r\n\r\n.aply-contact form .form-group .form-control {\r\n  height: 38px;\r\n  border: 1px solid #000;\r\n  border-radius: 6px;\r\n}\r\n\r\n.apply-btn {\r\n  font-size: 16px;\r\n  border: 1px solid #55b56d;\r\n  border-radius: 5px;\r\n  padding: 6px 20px;\r\n  background-color: #55b56d;\r\n  color: #fff;\r\n}\r\n\r\n.aply-btn {\r\n  background-color: #55b56d;\r\n  border-color: #55b56d;\r\n  border-radius: 5px;\r\n  padding: 8px 20px;\r\n  width: 130px;\r\n  margin: 20px auto 0px;\r\n  display: block;\r\n}\r\n\r\n.joblist-inner ul li i {\r\n  margin-right: 10px;\r\n}\r\n\r\n.joblist-inner img {\r\n  width: 55px;\r\n  margin: 0 auto;\r\n  display: block;\r\n}\r\n/**partner**/\r\n.brand {\r\n  /* background-color: #000; */\r\n  padding: 55px 0px;\r\n  /* margin-bottom: 60px; */\r\n}\r\n\r\n.brand-inner img {\r\n  width: 100%;\r\n  text-align: center;\r\n}\r\n\r\n.brand .col {\r\n  border-right: 1px dotted #000;\r\n  border-bottom: 1px dotted #000;\r\n  padding: 20px;\r\n}\r\n\r\n.brand .col:nth-child(6),\r\n.brand .col:nth-child(12),\r\n.brand .col:nth-child(18),\r\n.brand .col:nth-child(24),\r\n.brand .col:nth-child(30),\r\n.brand .col:nth-child(36) {\r\n  border-right: none;\r\n}\r\n\r\n.brand .col:nth-child(25),\r\n.brand .col:nth-child(26),\r\n.brand .col:nth-child(27),\r\n.brand .col:nth-child(28),\r\n.brand .col:nth-child(29),\r\n.brand .col:nth-child(30) {\r\n  border-bottom: none;\r\n}\r\n\r\n.brand h3 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 40px;\r\n  line-height: 50px;\r\n  text-align: center;\r\n  color: #202020;\r\n  margin-bottom: 35px;\r\n}\r\n\r\n.brand .carousel-item img {\r\n  border: 1px solid grey;\r\n  height: 70px;\r\n  padding: 12px 10px;\r\n}\r\n\r\n/**event**/\r\n.testimonialss .testimonials-box-left {\r\n  width: 48%;\r\n  display: flex;\r\n  margin: 0 auto;\r\n}\r\n\r\n.testimonialss .testimonials-box-right {\r\n  width: 48%;\r\n  display: flex;\r\n  margin: 0 auto;\r\n}\r\n\r\n.testimonialss .testimonials-box-left img {\r\n  width: 50%;\r\n}\r\n.testimonialss .testimonials-box-right img {\r\n  width: 50%;\r\n}\r\n\r\n.testimonialss .swiper-horizontal {\r\n  background-color: #000;\r\n}\r\n.testimonials .swiper-slide {\r\n  background-color: unset;\r\n}\r\n\r\n.testimonialss .testimonials-box {\r\n  background-color: unset !important;\r\n  padding: 55px 0px;\r\n}\r\n\r\n.testimonialss {\r\n  background-color: #000;\r\n}\r\n\r\n.testimonialss h3 {\r\n  color: #fff;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.tech-box h5 {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  font-size: 16px;\r\n  line-height: 24px;\r\n  color: #55b56d;\r\n  margin-bottom: 4px;\r\n  text-align: left;\r\n}\r\n\r\n.tech-box h6 {\r\n  font-size: 15px;\r\n  color: #fff;\r\n  font-family: \"Poppins\";\r\n  text-align: left;\r\n  margin-bottom: 0px;\r\n  margin-top: 12px;\r\n}\r\n\r\n.tech-box {\r\n  padding: 25px 20px;\r\n}\r\n\r\n.btn-dtl {\r\n  font-family: \"Poppins\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-size: 18px;\r\n  line-height: 18px;\r\n  border: 1px solid #55b56d;\r\n  transition: 0.5s;\r\n  padding: 8px 18px;\r\n  background-color: #55b56d;\r\n  color: #000;\r\n  margin-top: 20px;\r\n  display: inline-block;\r\n}\r\n\r\n.need-inner-right p {\r\n  color: #fff;\r\n  text-align: justify;\r\n}\r\n\r\n.src-loctaion .input-group {\r\n  width: 100%;\r\n  justify-content: space-around;\r\n}\r\n\r\n.src-loctaion .form-group {\r\n  width: 89%;\r\n}\r\n\r\n.src-loctaion select {\r\n  border-radius: 5px 0px 0px 5px;\r\n}\r\n\r\n.lrpTableR td:nth-child(1){\r\n  width: 28%;\r\n}\r\n\r\n.lrpTableR td{\r\n  text-align: left !important;\r\n  vertical-align: top;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.lrpTableR td ul li{\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.lrpCircle{\r\n  padding-left: 20px;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.lrpCircle li{\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
